import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import regbanner from "../../../assets/icons/panDob.svg";
import InputField from "../../UI/InputField/InputField";
import Button, { Verify } from "../../UI/Button/Button";
import addIcon from '../../../assets/icons/addIcon.svg';
import { authenticateNavBarObj, containerUrl, dashboardUrl, dematNavBarObj, hasNavBarEntry, leftNavBarArray, statusUrl, } from "../../utils/constants";
import { pan, emailRegex, phoneNo } from "../../utils/regex";
import "./PANInfo.scss";
import { PAN_REGEX, isMinor, buildFullName, convertDate, checkPanValidationMsgs, SUBTYPE_MAP } from "./PANInfoJoint.utils";
import { AGetClientDetailsByPan, AGetKraDetails, AGetEmployeeByPan, ACheckUCCExists, APanVerification, ASavePanDobDetailsJoint, ACheckKraPan, } from "../../Services/registration/panDobApiService";
import { AGetOtpNew, ALeadFetchApi, AValidateOtpNew, } from "../../Services/registration/registrationApiService";
import ErrMsg from "../../UI/ErrMsg/ErrMsg";
import GlobalStore from "../../store/globalStore";
import { useNavigate } from "react-router-dom";
import { clientContinue, utmDurationInfoObj, setStageData, ageCalculator, } from "../../Services/globalService";
import { APendingUploadList } from "../../Services/dashboard/eSignApiServices";
import { AGetCacheData, AGetStageCompletionStatus, } from "../../Services/registration/continueApiService";
import { checkModuleCompleteness } from "../../Profile/ProfileNavBar/ProfileNavBar";
import Calender from "../../UI/Calender/Calender";
import moment from "moment";
import gtmService from "../../Services/gtmService";
import cleverTapEvents from "../../../config/cleverTapEvents";
import mixpanelService from "../../Services/mixpanelService";
import mixpanelEvents, { getScreenName, webFlowEvents } from "../../../config/mixpanelEvents";
import { nonRouteScreenNames } from "../../../config/aopScreenNames";
import useQuery from "../../../customHooks/useQuery";
import { ClevertapService } from "../../Services/clevertapService";
import { DocDetailFormat } from "../../UI/DocumentBrowse/DocumentBrowse";
import { initialPanDocObj } from "../../DocumentVerification/DocVerificationForm/DocVerificationForm";
import { QCServiceTaskCreation } from "../../Services/dashboard/docVerificationAPIServices";
import { AUploadDocument } from "../../Services/dashboard/brokerageServices";
import { AppsFlyerService } from "../../Services/appsFlyerService";
import appsFlyerEvents from "../../../config/appsFlyerEvents";
import Checkbox from "../../UI/Checkbox/Checkbox";
import config from "../../../config/domain";
import { errorCode, errorMsg } from "../../../ErrorCode/ErrorCode";
import Loader from "../../UI/Loader/Loader";
import { getProfileDetailsFromAadhar } from "../ShareAdd/ShareAdd";
import DropdownSearch from "../../UI/DropdownSearch/DropdownSearch";
import RegOtp from "../RegOtp/RegOtp";
import Backdrop from "../../UI/Backdrop/Backdrop";

export interface IPanDobFields {
  pan: string;
  dob: Date | null;
  aadharLinked: "No" | "Yes" | "Not Sure";
  aadhaarNo?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  fatherName?: string;
  gurdianPanNo?: any;
  gurdianDOB?: Date | null;
  gurdianFName?: string;
  gurdianMName?: string;
  gurdianLName?: string;
  fullname?: any;
  minorPan?: string;
  relationshipId?: string;
}

export interface iGeoLocation {
  loaded: boolean;
  coordinates: { lat: string; lng: string };
  error: boolean;
}

export type saveDocumentObj = {
  documentCategoryId?: string;
  documentId?: string;
  fileName: string;
  isfilecropped: boolean;
  mimeType: string | undefined;
  panno: string;
  personaldetailsid: string;
  autoqc: boolean;
  iskycdocument: boolean;
  documentNumber?: string;
};

export interface ILocalQueryObject {
  email?: string;
  mobile?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  pan?: string;
  dob?: string;
  productid?: string;
  categoryid?: string;
  rmid?: string;
  leadid?: string;
  accountCategory?: string;
  createdBy?: any;
  entityType?: any;
  clienttype?: any;
  entitySubType?: any;
  is_guradian_pan?: any;
  fullname?: any;
  applicationID?: any;
  uccCode?: any;
}

interface AccountHolder {
  id: number;
  isPrimary?: boolean;
  name?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  pan?: string;
  dob?: any;
  relation?: string;
  email?: string;
  mobile?: string;
  [key: string]: any;
}

export interface PANInfoProps { }

const relationShipList = [
  // {
  //   display: "Father",
  //   value: 1,
  // },
  // {
  //   display: "Mother",
  //   value: 2,
  // },
  {
    display: "Self",
    value: 1,
  },
  {
    display: "Spouse",
    value: 2,
  },
  {
    display: "Dependent Child",
    value: 3,
  },
  {
    display: "Dependent Parent",
    value: 4,
  }
];

const PANInfoJoint: React.FC<PANInfoProps> = () => {
  const isPanLinkedToAadharRef = useRef<boolean>(false);
  const [entityType, setEntityType] = useState(GlobalStore.entityType || "");
  const [entitySubType, setEntitySubType] = useState(GlobalStore.entitySubType || "");
  const quryParams = useQuery();
  const UTM_SOURCE = quryParams.get("utm_source") ? quryParams.get("utm_source") : "";
  const UTM_MEDIUM = quryParams.get("utm_medium") ? quryParams.get("utm_medium") : "";
  const UTM_CAMPAIGN = quryParams.get("utm_campaign") ? quryParams.get("utm_campaign") : "";
  let localURL = localStorage.getItem("currentURL"), navigateURL: string = "";
  const localProductCode = quryParams.get("productCode");
  const id = quryParams.get("id");
  const name = quryParams.get("name");
  const skipUrl = quryParams.get("skipUrl");

  const [dematAccountFound, setDematAccountFound] = React.useState<any>(null);
  if (
    localURL !== null &&
    localURL !== undefined &&
    localURL !== "" &&
    localURL?.length > 0
  ) {
    navigateURL = window.atob(localURL);
    localURL = window.atob(localURL);
  }
  const [prodObj, setProdObj] = React.useState<ILocalQueryObject>({});
  const [values, setValues] = React.useState<IPanDobFields>({
    pan: "",
    aadharLinked: "No",
    dob: null,
    //aadhaarNo: "",
    firstName: "",
    middleName: "",
    lastName: "",
    fatherName: "",
    minorPan: "",
    relationshipId: "",
  });
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [errCode, setErrCode] = React.useState<any>("");
  const [errors, setErrors] = React.useState<{ [key in keyof IPanDobFields]?: string }>({
    pan: undefined,
    dob: undefined,
    aadharLinked: undefined,
    aadhaarNo: undefined,
    firstName: undefined,
    middleName: undefined,
    lastName: undefined,
  });
  // const history = useHistory();
  const navigate = useNavigate()
  let isEmployee: boolean = false;
  const [utmObj, setUtmObj] = React.useState<any>(null);
  const [consent, setConsent] = React.useState<boolean>(true);
  const [togPhoto, setTogPhoto] = React.useState<boolean>(false);
  const [panNumberMatched, setPanNumberMatched] = React.useState(false);
  const [dobChecked, setDobChecked] = React.useState(false);
  const [isNormalClient, setIsNormalClient] = React.useState<boolean>(false);
  const [skipUrlBoolean, setSkipUrlBoolean] = React.useState<boolean>(false);
  const [errorFoundInPanValidation, setErrorFoundInPanValidation] = useState<boolean>(false);
  const [cacheResponse, setCacheResponse] = React.useState<any>(null);
  const [liveLocationCheck, setLiveLocationCheck] = useState<any>({
    checkPhotoLiveness: false,
    checkLocation: false,
  });
  const [panOCR, setPanOCR] = useState<any>(null);
  const [willDoLater, setWillDoLater] = useState<boolean>(false);
  const [panFileUploaded, setPanFileUploaded] = useState<boolean>(false);
  const [panFileUploadedLoader, setPanFileUploadedLoader] = useState<boolean>(false);
  const [invalidPanFieldUploadedMsg, setInvalidPanFileUploadedMsg] = React.useState<string>("");
  const [applicationModeType, setApplicationModeType] = useState<any>("");
  const [modalDisplayText, setModalDisplayText] = useState<any>("");
  const [showSubmitModal, setShowSubmitModal] = useState<boolean>(false);

  // Non-KRA clients are shown the DigiLocker consent note on this page. It is
  // its own screen for analytics even though it shares the /pan route, so it
  // is fired here rather than from the route based MixpanelPageTracker.
  const nonKraConsentTracked = React.useRef(false);
  React.useEffect(() => {
    if (
      showSubmitModal &&
      applicationModeType === "isDigiLocker" &&
      !nonKraConsentTracked.current
    ) {
      nonKraConsentTracked.current = true;
      mixpanelService({
        event: mixpanelEvents.SCREEN_LOAD,
        screen_name: nonRouteScreenNames.nonKraConsentSelection,
      });
    }
  }, [showSubmitModal, applicationModeType]);
  const [panInvalidMsg, setPanInvalidMsg] = React.useState<string>("");
  let panValidationResp: any;
  const [applicationInitializedFlag, setApplicationInitializedFlag] = useState<boolean>(false);
  const [submitFlag, setSubmitFlag] = useState<boolean>(false);
  const [extractPanResponse, setExtractPanResponse] = React.useState<{
    age: number;
    date_of_birth: string;
    date_of_issue: string;
    fathers_name: string;
    id_number: string;
    is_scanned: boolean;
    minor: boolean;
    name_on_card: string;
    pan_type: string;
  }>();
  const [documentsInfo, setDocumentInfo] = useState({
    totalDocs: [],
    totalDocsCount: 0,
    uploadedDocsCount: 0,
  });
  const [accHolders, setAccHolders] = useState<AccountHolder[]>([
    { id: 2, firstName: "", middleName: "", lastName: "", pan: "", dob: "", relation: "", email: "", mobile: "" }, // default holder 2
  ]);

  const [holderErrors, setHolderErrors] = useState<any>({});
  const [holderOtpStates, setHolderOtpStates] = useState<any>({});
  const [holderVerificationStates, setHolderVerificationStates] = useState<any>({});
  const [invalidOtp, setInvalidOtp] = useState(false);
  const [invalidEmailOtp, setInvalidEmailOtp] = useState(false);

  const initializeHolderOtpState = (holderId: number) => {
    setHolderOtpStates((prev: any) => ({
      ...prev,
      [holderId]: {
        email: '',
        mobile: '',
        emailSent: false,
        mobileSent: false,
        emailTimer: 0,
        mobileTimer: 0,
      }
    }));

    setHolderVerificationStates((prev: any) => ({
      ...prev,
      [holderId]: {
        emailVerified: false,
        mobileVerified: false,
      }
    }));
  };

  const handleAddHolder = () => {
    if (accHolders.length < 3) {
      const newHolder = { id: 3, name: "", pan: "", dob: "", relation: "", email: "", mobile: "" };
      setAccHolders(prev => [...prev, newHolder]);
      initializeHolderOtpState(newHolder.id);
    }
  };

  useEffect(() => {
    if (accHolders.length > 0) {
      accHolders.forEach(holder => {
        initializeHolderOtpState(holder.id);
      });
    }
  }, []);

  const handleSendEmailOTP = async (holderId: number, email: string) => {
    if (!email || !emailRegex.test(email)) {
      return;
    }

    try {
      setIsLoading(true);
      AGetOtpNew(
        (res: any) => {
          if (res?.data?.data !== null && res?.data?.data !== undefined && !!res?.data?.data?.OTPId && res?.data?.data?.OTPId !== "") {
            setHolderOtpStates((prev: any) => ({
              ...prev,
              [holderId]: {
                ...prev[holderId],
                email: email,
                emailSent: true,
                emailTimer: 15,
                emailOtpId: res?.data?.data?.OTPId,
              }
            }));
            const interval = setInterval(() => {
              setHolderOtpStates((prev: any) => {
                const currentTimer = prev[holderId]?.emailTimer || 0;
                if (currentTimer <= 1) {
                  clearInterval(interval);
                  return {
                    ...prev,
                    [holderId]: {
                      ...prev[holderId],
                      emailTimer: 0,
                    }
                  };
                }
                return {
                  ...prev,
                  [holderId]: {
                    ...prev[holderId],
                    emailTimer: currentTimer - 1,
                  }
                };
              });
            }, 1000);
            setErrCode("");
          } else {
            if (res?.error) {
              setErrCode(res.error);
            } else {
              setErrCode("Failed to send Email OTP, please retry.");
            }
          }
          setIsLoading(false);
        },
        email,
        "EMAIL"
      );
    } catch (error) {
      setIsLoading(false);
      setErrCode("Failed to send Email OTP");
    }
  };

  const handleSendMobileOTP = async (holderId: number, mobile: string) => {
    if (!mobile || !phoneNo.test(mobile) || mobile.length !== 10) {
      return;
    }
    try {
      setIsLoading(true);
      AGetOtpNew(
        (res: any) => {
          if (
            res?.data?.data !== null &&
            res?.data?.data !== undefined &&
            !!res?.data?.data?.OTPId &&
            res?.data?.data?.OTPId !== ""
          ) {
            setHolderOtpStates((prev: any) => ({
              ...prev,
              [holderId]: {
                ...prev[holderId],
                mobile: mobile,
                mobileSent: true,
                mobileTimer: 15,
                mobileOtpId: res?.data?.data?.OTPId,
              }
            }));
            const interval = setInterval(() => {
              setHolderOtpStates((prev: any) => {
                const currentTimer = prev[holderId]?.mobileTimer || 0;
                if (currentTimer <= 1) {
                  clearInterval(interval);
                  return {
                    ...prev,
                    [holderId]: {
                      ...prev[holderId],
                      mobileTimer: 0,
                    }
                  };
                }
                return {
                  ...prev,
                  [holderId]: {
                    ...prev[holderId],
                    mobileTimer: currentTimer - 1,
                  }
                };
              });
            }, 1000);

            setErrCode("");
          } else {
            if (res?.error) {
              setErrCode(res.error);
            } else {
              setErrCode("Failed to send mobile OTP, please retry.");
            }
          }
          setIsLoading(false);
        },
        mobile,
        "SMS"
      );
    } catch (error) {
      setIsLoading(false);
      setErrCode("Failed to send Email OTP");
    }
  };

  function validateOtp(holderId: number, otpType: "email" | "mobile", val: string) {
    if (invalidOtp) {
      setInvalidOtp(false);
    }
    if (invalidEmailOtp) {
      setInvalidEmailOtp(false);
    }
    if (val.length === 4) {
      setIsLoading(true);
      AValidateOtpNew(
        (res: any) => {
          if (otpType === "email") {
            checkEmailValidateOtpNew(res, holderId);
          } else {
            checkMobileValidateOtpNew(res, holderId);
          }
        },
        otpType === "email" ? holderOtpStates[holderId]?.emailOtpId : holderOtpStates[holderId]?.mobileOtpId,
        val
      );
    }
  }

  function checkEmailValidateOtpNew(res: any, holderId: any) {
    if (!res || res.error) {
      setErrCode(res.error);
    } else {
      if (
        res.data &&
        res?.data?.data &&
        !!res?.data?.success &&
        res?.data?.success == true
      ) {
        setIsLoading(true);
        setHolderVerificationStates((prev: any) => ({
          ...prev,
          [holderId]: {
            ...prev[holderId],
            emailVerified: true,
          }
        }));
        setIsLoading(false);
      } else {
        setInvalidEmailOtp(true);
      }
      setErrCode("");
    }
    setIsLoading(false);
  }

  function checkMobileValidateOtpNew(res: any, holderId: any) {
    setIsLoading(false);
    if (res.error) {
      setErrCode(res.error);
    } else {
      if (
        res.data &&
        res?.data?.data &&
        !!res?.data?.success &&
        res?.data?.success == true
      ) {
        setIsLoading(true);
        setHolderVerificationStates((prev: any) => ({
          ...prev,
          [holderId]: {
            ...prev[holderId],
            mobileVerified: true,
          }
        }));
        setIsLoading(false);
      } else {
        setInvalidOtp(true);
      }
      setErrCode("");
    }
  }

  const objAccType = useMemo(() =>
    window.sessionStorage.getItem("objAccType") || "",
    []
  );

  const splitName = (fullName = "") => {
    const parts = fullName.trim().split(" ").filter(Boolean);

    let firstName = "";
    let middleName = "";
    let lastName = "";

    if (parts.length === 1) {
      firstName = parts[0];
    } else if (parts.length === 2) {
      firstName = parts[0];
      lastName = parts[1];
    } else if (parts.length >= 3) {
      firstName = parts[0];
      lastName = parts[parts.length - 1];
      middleName = parts.slice(1, -1).join(" ");
    }

    return { firstName, middleName, lastName };
  };

  const updateJointHolders = (response: any) => {
    setAccHolders((prev) => {
      let updated = [...prev];
      // ---------- FIRST JOINT HOLDER (ID: 2) ----------
      if (response.firstJointHolderName || response.firstJointHolderPan) {
        const { firstName, middleName, lastName } = splitName(response.firstJointHolderName || "");

        const firstHolder = {
          id: 2,
          firstName,
          middleName,
          lastName,
          pan: response.firstJointHolderPan || "",
          dob: response.firstJointHolderDOB || "",
          relation: response.firstJointHolderRelationId || "",
          email: response.firstJointHolderEmail || "",
          mobile: response.firstJointHolderMobile || "",
          isDisabled: response?.uccCode || false
        };

        const idx = updated.findIndex((h) => h.id === 2);
        if (idx !== -1) updated[idx] = { ...updated[idx], ...firstHolder };
        else updated.push(firstHolder);
      }
      // ---------- SECOND JOINT HOLDER (ID: 3) ----------
      if (response.secondJointHolderName || response.secondJointHolderPan) {
        const { firstName, middleName, lastName } = splitName(response.secondJointHolderName || "");

        const secondHolder = {
          id: 3,
          firstName,
          middleName,
          lastName,
          pan: response.secondJointHolderPan || "",
          dob: response.secondJointHolderDOB || "",
          relation: response.secondJointHolderRelationId || "",
          email: response.secondJointHolderEmail || "",
          mobile: response.secondJointHolderMobile || "",
          isDisabled: response?.uccCode || false
        };

        const idx = updated.findIndex((h) => h.id === 3);
        if (idx !== -1) updated[idx] = { ...updated[idx], ...secondHolder };
        else updated.push(secondHolder);
      }

      return updated;
    });
  };

  const buildJointHolderDetails = (accHolders: any[], relationShipList: any[]) => {
    return accHolders
      .filter((holder) => !holder.isPrimary)
      .map((holder, index) => {
        const fullName = `${holder.firstName ?? ""} ${holder.middleName ?? ""} ${holder.lastName ?? ""}`
          .replace(/\s+/g, " ")
          .trim();

        return {
          emailID: holder.email || "",
          mobileno: holder.mobile || "",
          panNo: holder.pan || "",
          dob: holder.dob ? moment(holder.dob).format("MM/DD/YYYY") : null,
          relationName:
            relationShipList.find((e: any) => e.value == holder.relation)?.display || "",
          relationId: holder.relation || 0,
          panFName: holder.firstName || "",
          panMName: holder.middleName || "",
          panLName: holder.lastName || "",
          panFSName: fullName || "",
          holderId: `HOLDER${index + 1}`,
          isEmailVerified: holderVerificationStates[holder.id]?.emailVerified ?? false,
          isMobileVerified: holderVerificationStates[holder.id]?.mobileVerified ?? false
        };
      });
  };

  useEffect(() => {
    sessionStorage.setItem("accHolders", JSON.stringify(buildJointHolderDetails(accHolders, relationShipList)));
  }, [accHolders])

  function onChange(key: keyof IPanDobFields, value: string | Date) {
    if (key === "aadharLinked" && typeof value === "string") {
      gtmService({
        action: "PAN_DOB",
        label: `AADHAR_LINK | ${value.toUpperCase()}`,
      });
    }

    if (key === "dob" && typeof value !== "string") {
      setErrCode(errCode);

      if (ageCalculator(value) >= 60)
        window.sessionStorage.setItem("isSeniorCitizen", "true");
      else
        window.sessionStorage.setItem("isSeniorCitizen", "false");
    }

    if (key === "dob" && entityType === "NONINDIVIDUAL") {
      GlobalStore.dateOfIncorporation = moment(value).format("YYYY-MM-DD");
    }
    setErrors({ ...errors, [key]: "" });
    setValues({ ...values, [key]: value });
  }

  React.useEffect(() => {
    setEntityType(GlobalStore.entityType)
    setEntitySubType(GlobalStore.entitySubType)
    const objUtm = JSON.parse(
      window.sessionStorage.getItem("objUTM_Info") || "{}"
    );
    setUtmObj(objUtm);
    if (
      containerUrl.continue === clientContinue() &&
      !GlobalStore.isPartialFilledClient
    ) {
      navigate(containerUrl.continue);
      return;
    }
    if (!GlobalStore.leadId || GlobalStore.leadId === "") {
      return;
    }
    init();
    window.scroll(0, 0);
    if (
      skipUrl !== null &&
      skipUrl !== undefined &&
      skipUrl !== "" &&
      skipUrl?.toLowerCase() == "yes"
    ) {
      if (
        id !== null &&
        id !== undefined &&
        id !== "" &&
        id?.length > 0 &&
        name !== null &&
        name !== undefined &&
        name !== "" &&
        name?.length > 0
      ) {
        // setIsLoading(true);
        setPanFileUploadedLoader(true);
        ALeadFetchApi(
          (res: any) => {
            if (!res || res.error) {
              // setErrCode(164)
              setErrCode(errCode + res.error);
              setSkipUrlBoolean(true);
              setPanFileUploaded(true);
              // gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR124" });
            } else if (res?.data) {
              if (Array?.isArray(res?.data) && res?.data?.length > 0) {
                let productObj = res?.data[0] as ILocalQueryObject;
                updateJointHolders(productObj)
                GlobalStore.externalDetails = productObj
                GlobalStore.entityType = productObj?.entityType
                GlobalStore.entitySubType = productObj?.entitySubType
                if (productObj?.entitySubType == "Minor") {
                  setEntitySubType("Minor")
                } else if (productObj?.entityType == "NONINDIVIDUAL" || productObj?.entityType == "NON INDIVIDUAL") {
                  setEntityType("NONINDIVIDUAL")
                  GlobalStore.entityType = "NONINDIVIDUAL"
                }
                setPanFileUploadedLoader(false);
                if (productObj?.createdBy != null && productObj?.createdBy !== undefined) {
                  setProdObj(productObj);
                  setSkipUrlBoolean(true);
                  setWillDoLater(true);
                  setDobChecked(true);
                  setValues((values) => {
                    if (productObj?.fullname) {
                      values.fullname = productObj.fullname
                    }
                    if (productObj?.pan) {
                      if (productObj?.is_guradian_pan) {
                        values.gurdianPanNo = productObj.pan;
                      } else {
                        values.pan = productObj.pan;
                        values.minorPan = "yes"
                      }
                    }
                    if (productObj?.dob) {
                      const formattedDob = moment(moment(convertDate(productObj?.dob)).toDate())
                        .startOf("day")
                        .toDate();
                      values.dob = formattedDob;
                      if (ageCalculator(values.dob) > 60) {
                        window.sessionStorage.setItem("isSeniorCitizen", "true");
                      } else {
                        window.sessionStorage.setItem("isSeniorCitizen", "false");
                      }
                    }
                    if (productObj?.firstName) {
                      values.firstName = productObj.firstName;
                    }
                    if (productObj?.middleName) {
                      values.middleName = productObj.middleName;
                    }
                    if (productObj?.lastName) {
                      values.lastName = productObj.lastName;
                    }
                    if (productObj?.leadid) {
                      GlobalStore.leadId = productObj?.leadid;
                    }
                    if (productObj?.email) {
                      GlobalStore.user.email = productObj?.email;
                    }
                    if (productObj?.mobile) {
                      GlobalStore.user.mobile = productObj?.mobile;
                    }
                    if (productObj?.createdBy) {
                      GlobalStore.user.rmCode = productObj?.createdBy;
                    }
                    if (productObj?.accountCategory) {
                      GlobalStore.accountcategory = parseInt(productObj?.accountCategory);
                      GlobalStore.user.accountType = parseInt(productObj?.accountCategory) == 2 ? "I" : "TD";
                    }
                    let PANFirstName = productObj?.firstName;
                    let PANMiddleName = productObj?.middleName ?? "";
                    let PANlastName = productObj?.lastName ?? "";

                    if (PANFirstName === "" && PANlastName !== "") {
                      PANFirstName = PANlastName;
                      GlobalStore.personaldetails.PANName = PANFirstName;
                      PANlastName = "";
                      if (PANMiddleName !== "") {
                        GlobalStore.personaldetails.PANName =
                          GlobalStore.personaldetails.PANName +
                          " " +
                          PANMiddleName;
                      }
                    }
                    else if (PANFirstName === "" && PANMiddleName === "" && PANlastName === "") {
                      GlobalStore.personaldetails.PANName = "";
                    }
                    else if (PANMiddleName === "") {
                      GlobalStore.personaldetails.PANName = PANFirstName + " " + PANlastName;
                      PANMiddleName = "";
                    }
                    else {
                      GlobalStore.personaldetails.PANName = PANFirstName + " " + PANMiddleName + " " + PANlastName;
                    }

                    GlobalStore.personaldetails.firstname = PANFirstName;
                    GlobalStore.personaldetails.lastname = PANlastName;
                    GlobalStore.personaldetails.middlename = PANMiddleName;
                    let reqObj: any = {
                      pan: productObj.pan,
                      accountType: productObj?.accountCategory,
                      rmId: productObj?.createdBy,
                    };
                    let newReqObj = {
                      rmid: productObj?.createdBy,
                      skipUrlBoolean: true,
                    };
                    AgetClientDetailsByPANNew(reqObj, newReqObj);
                    return values;
                  });
                  setPanFileUploaded(true);
                }
              }
            }
          },
          {
            id: encodeURIComponent(id),
            name: encodeURIComponent(name),
            stageFlag: 1,
          }
        );
      }
    } else {
      if (!GlobalStore.user.email || !GlobalStore.user.mobile) {
        if (!!navigateURL) {
          setSkipUrlBoolean(false);
          window.location.href = navigateURL;
        }
      }
    }
  }, []);

  React.useEffect(() => {
    const data = {
      EventName: cleverTapEvents.registration.panPage.PAGE_LOAD,
      InitiationPlatform: "",
      UTM_SOURCE,
      UTM_MEDIUM,
      UTM_CAMPAIGN,
      LEAD_ID: GlobalStore.leadId,
      REF_ID: "",
    };
    ClevertapService.pushEvent(data);
  }, []);

  React.useEffect(() => {
    const primaryAcc: AccountHolder = {
      id: 1,
      isPrimary: true,
      firstName: values.firstName ?? "",
      middleName: values.middleName ?? "",
      lastName: values.lastName ?? "",
      pan: values.pan ?? "",
      dob: values.dob ?? "",
      relation: "",
      email: GlobalStore?.user?.email,
      mobile: GlobalStore?.user?.mobile,
      isDisabled: (values.firstName != "" && values.middleName != "" && values.lastName != "" && values.pan != "" && values.dob != null) || prodObj?.uccCode
    };
    setAccHolders((prev) => {
      const index = prev.findIndex((a) => a.id === 1);
      if (index !== -1) {
        const updated = [...prev];
        updated[index] = primaryAcc;
        return updated;
      } else {
        return [primaryAcc, ...prev];
      }
    });
  }, [values.firstName]);

  React.useEffect(() => {
    if (applicationModeType === "isKRA") {
      setModalDisplayText(
        "As per SEBI Regulations, under the Income Tax Guidelines we have successfully verified your Name on the Income Tax Website. Your application is pre-filled since you are an existing KRA Validated Customer."
      );
    } else if (applicationModeType === "isDigiLocker") {
      setModalDisplayText(
        "As per SEBI Regulations, under the Income Tax Guidelines we have successfully verified your Name on the Income Tax Website. We suggest completing your journey using Digilocker. For Using Digilocker your Aadhar and Mobile should be linked. It is not mandatory to have a Digilocker account. This will help you to speed up your activation process."
      );
    }
  }, [applicationModeType]);

  React.useEffect(() => {
    if (GlobalStore.user) {
      setValues((values) => {
        values.firstName = GlobalStore.user.firstname;
        values.lastName = GlobalStore.user.lastName
        values.middleName = GlobalStore.user.middleName
        return values
      })
    }
  }, [GlobalStore.user])

  const registerCleverTapEventAfterProceed = () => {
    const data = {
      EventName: cleverTapEvents.registration.panPage.CLICK_ON_PROCEED,
      InitiationPlatform: "",
      UTM_SOURCE,
      UTM_MEDIUM,
      UTM_CAMPAIGN,
      LEAD_ID: GlobalStore.leadId,
      REF_ID: GlobalStore.applicationID,
      KRA: GlobalStore.isKRA,
      ADHAR_LINKED_WITH_MOBILE: GlobalStore.aadharLinkedChoice,
    };
    ClevertapService.pushEvent(data);

    // Apps flyer event for click on proceed on pan details page
    AppsFlyerService.pushEvent(
      appsFlyerEvents.registration.panPage.CLICK_ON_PROCEED
    );
    mixpanelService({
      event: webFlowEvents.pan.SUCCESS,
      account_type: "joint",
      kra: GlobalStore.isKRA,
      aadhar_linked_with_mobile: GlobalStore.aadharLinkedChoice,
    });
  };

  function init() {
    window.sessionStorage.setItem("isSeniorCitizen", "false");
    window.localStorage.removeItem("isAadhaarVerified");
    GlobalStore.personaldetails = {
      firstname: GlobalStore.user.firstname,
      lastname: GlobalStore.user.lastName,
      middlename: "",
      mobile: GlobalStore.user.mobile,
      emailId: GlobalStore.user.email,
      aadhaar: "",
      pan: "",
      gender: "",
      dob: "",
      additionalemail: "",
      additionalmobile: "",
      PANName: "",
      adrLine1: "",
      adrLine2: "",
      city: "",
      state: "",
      pincode: "",
    };
  }

  const UccCheckNewCalled = (res: any, callBackFunction: Function) => {
    if (!res || res.error) {
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res.error);
      }
      setIsLoading(false);
      gtmService({ action: "CheckUCCExists", label: "ERROR || ERR105" });
      mixpanelService({
        event: mixpanelEvents.ERROR_TRIGGERED,
        screen_name: getScreenName(window.location.pathname),
        error_object: res.error,
      });
    }
    else {
      if (
        !!res?.data &&
        res?.data?.Source === 1 &&
        res?.data?.IbeatsCheck !== null &&
        res?.data?.IbeatsCheck !== undefined &&
        res?.data?.IbeatsCheck
      ) {
        registerCleverTapEventAfterProceed();
        gtmService({ action: "PAN_DOB", label: "Step_Complete" });
        navigate(containerUrl.accexists)
        setIsLoading(false);
      } else if (
        !!res?.data &&
        res?.data?.Source === 2 &&
        res?.data?.UccCheck !== null &&
        res?.data?.UccCheck !== undefined &&
        res?.data?.UccCheck
      ) {
        callBackFunction();
      }
    }
  };

  async function panFunction() {
    const kraResults: boolean[] = [];

    for (const acc of accHolders.filter((a) => a.pan && a.dob)) {
      const result = await new Promise<boolean>((resolve) => {
        const formattedDob = acc.dob ? moment(acc.dob).format("DD/MM/YYYY") : "";
        let rawName = `${acc.firstName ?? ""} ${acc.middleName ?? ""} ${acc.lastName ?? ""}`;
        const applicantName = rawName.replace(/\s+/g, " ").trim();

        if (!formattedDob) {
          resolve(false);
          return;
        }

        panValidation(
          {
            panNo: acc.pan || "",
            name: applicantName,
            dob: formattedDob,
            source: "DIY",
          },
          (result: boolean) => {
            resolve(!!result);
          }
        );
      });

      kraResults.push(result);
      if (result === true) {
        break;
      }
    }
    return kraResults;
  }

  async function handleSubmit(e?: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement>) {
    e?.preventDefault?.();
    setErrCode("");
    setIsLoading(true);

    if (!values.pan || !PAN_REGEX.test(values.pan)) {
      setErrCode("Invalid PAN");
      setIsLoading(false);
      return;
    }

    if (!values.dob) {
      setErrors((prev) => ({
        ...prev,
        dob: errorMsg(errorCode.FE10),
      }));
      setIsLoading(false);
      return;
    }

    if (values.dob && isMinor(values.dob)) {
      setErrCode("The primary holder PAN belongs to a minor.");
      setIsLoading(false);
      return;
    }

    const accountType = getAccountCategory() ?? 1;

    try {
      const kraResults = await Promise.all(
        accHolders
          .filter((a) => a.pan && a.dob && a.email && a.mobile)
          .map(
            (acc) =>
              new Promise<boolean>((resolve) => {
                ACheckKraPan(
                  (res: any) => {
                    const isKraValid = !!res?.data?.IsKra;
                    resolve(isKraValid);
                  },
                  acc.pan,
                  moment(acc.dob).format("DD/MM/YYYY"),
                  acc.email,
                  acc.mobile,
                  GlobalStore.applicationID
                );
              })
          )
      );

      const allTrue = kraResults.every(value => value === true);

      if (!allTrue) {
        setPanInvalidMsg("All the PANs need to be KRA valid");
        setErrCode("");
        setIsLoading(false);
        setSubmitFlag(true);
        return;
      }

      const proceedAfterPan = async () => {
        const isPanEmployee = await Promise.all(
          accHolders
            .filter((a) => a.pan && a.dob && a.email && a.mobile)
            .map(
              (acc: any) =>
                new Promise<boolean>((resolve, reject) => {
                  AGetEmployeeByPan(
                    (res: any) => {
                      try {
                        resolve(checkIsPanEmployee(res));
                      } catch (e) {
                        reject(e);
                      }
                    },
                    acc.pan
                  );
                })
            )
        );
        // AGetEmployeeByPan(checkIsPanEmployee, values.pan);
        const jointHolderDetails = buildJointHolderDetails(accHolders, relationShipList);

        ACheckUCCExists(
          (res: any) => {
            UccCheckNewCalled(res, panFunction);
          },
          values.pan,
          GlobalStore.user.mobile,
          GlobalStore.user.email,
          GlobalStore.leadId,
          prodObj?.createdBy ? parseInt(prodObj.createdBy) : 0,
          accountType,
          getProductCode(),
          "",
          "",
          "",
          jointHolderDetails
        );
      };
      setPanInvalidMsg("");
      proceedAfterPan();
    } catch (err) {
      console.error("Error checking PANs:", err);
      setIsLoading(false);
    }
  }

  function checkIsPanEmployee(res: any) {
    if (res && res.status) {
      const responseDataObj = res.data;
      if (responseDataObj.result.Flag === "Y") isEmployee = true;
      return true
    } else {
      if (!res || res.error) {
        if (errCode?.includes(res.error)) {
          setErrCode(errCode);
        } else {
          setErrCode(errCode + res.error);
        }
        gtmService({
          action: "GetEmployeeDetailsByPAN",
          label: "ERROR || ERR109",
        });
      }
      return false
    }
  }

  function checkPendingUploadNew(res: any, reqObj?: any) {
    let dematAccountFoundLocal: any = null;
    if (!res || res.error) {
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      }
      else {
        setErrCode(errCode + res.error);
      }
      gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR112" });
      setIsLoading(false);
    }
    else {
      if (res && res?.data == null) {
        let isUploadDocumentsCompleted: boolean = false;
        AGetStageCompletionStatus(
          (res: any) =>
            getClientStageDetailsNew(res, isUploadDocumentsCompleted, reqObj),
          GlobalStore.applicationID
        );
      } else if (res && res.data !== null) {
        const list: Array<any> = JSON.parse(res.data).filter(
          (item: any) => item.Mandatory == true
        );
        let isUploadDocumentsCompleted: boolean = false;
        if (
          list !== undefined &&
          list !== null &&
          list?.length > 0 &&
          list?.length === 1
        ) {
          dematAccountFoundLocal = list.find(
            (listObj) =>
              listObj?.DocumentCategory == "DP Document" &&
              listObj?.DocumentCategoryId == 96
          );
          if (
            dematAccountFoundLocal !== undefined &&
            dematAccountFoundLocal !== null
          ) {
            setDematAccountFound((dematAccountFound: any) => {
              dematAccountFound = dematAccountFoundLocal;
              return dematAccountFound;
            });
            //  completeModuleStatus(dashboardUrl.demat);
            // history.push(dashboardUrl.demat);
            // return;
          }
        }
        if (list !== undefined && list !== null && list?.length > 0 && list?.length > 1) {
          dematAccountFoundLocal = list.find(
            (listObj) =>
              listObj?.DocumentCategory == "DP Document" &&
              listObj?.DocumentCategoryId == 96
          );
          if (
            dematAccountFoundLocal !== undefined &&
            dematAccountFoundLocal !== null
          ) {
            setDematAccountFound((dematAccountFound: any) => {
              dematAccountFound = dematAccountFoundLocal;
              return dematAccountFound;
            });
          }
        }
        if (list.length === 0 || list[0].count === 0)
          isUploadDocumentsCompleted = true;

        AGetStageCompletionStatus(
          (res: any) =>
            getClientStageDetailsNew(
              res,
              isUploadDocumentsCompleted,
              reqObj,
              dematAccountFoundLocal
            ),
          GlobalStore.applicationID
        );
      } else {
        if (errCode?.includes(res.error)) {
          setErrCode(errCode);
        } else {
          setErrCode(errCode + res.error);
        }
        setIsLoading(false);
      }
    }
  }

  function getClientStageDetailsNew(
    res: any,
    isUploadDocumentsCompleted: boolean,
    reqObj?: any,
    dematAccountFoundLocaL?: any
  ) {
    if (!res || res.error) {
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res.error);
      }
      gtmService({
        action: "GetStageCompletionStatus",
        label: "ERROR || ERR113",
      });
      setIsLoading(false);
    } else {
      if (res.data && res.data !== null) {
        const responseObj = JSON.parse(res.data);
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        setStageData(responseObj);
        //check completeness of stages
        checkModuleCompleteness(
          isUploadDocumentsCompleted,
          dematAccountFoundLocaL ? dematAccountFoundLocaL : dematAccountFound
        );
        if (!clientPartialDetails_ao.mobile) {
          clientPartialDetails_ao.mobile = responseObj.mobileno;
        }

        if (!clientPartialDetails_ao.emailID) {
          clientPartialDetails_ao.emailID = responseObj.emailid;
        }
        clientPartialDetails_ao.pan = GlobalStore.personaldetails.pan;

        clientPartialDetails_ao.clientPrimaryDetailId =
          GlobalStore.clientPrimaryDetailId;
        clientPartialDetails_ao.applicationId = GlobalStore.applicationID;
        clientPartialDetails_ao.accountcategory = GlobalStore.accountcategory;
        clientPartialDetails_ao.token = GlobalStore.token;
        if (
          responseObj?.fatherspousename != null &&
          responseObj?.fatherspousename != undefined &&
          responseObj?.fatherspousename !== ""
        ) {
          clientPartialDetails_ao.fsfullName = responseObj?.fatherspousename;
        }
        clientPartialDetails_ao.dpid = responseObj?.dpid;
        clientPartialDetails_ao.clientid = responseObj?.dpclientid;
        GlobalStore.dpid = responseObj?.dpid;
        GlobalStore.clientid = responseObj?.dpclientid;
        GlobalStore.entityType = responseObj?.entitytype;
        GlobalStore.entitySubType = responseObj?.entitysubtype
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        setStageData(responseObj);
        let cacheData = null;
        checkModuleCompleteness(
          isUploadDocumentsCompleted,
          dematAccountFoundLocaL ? dematAccountFoundLocaL : dematAccountFound
        );
        if (
          reqObj?.skipUrlBoolean &&
          reqObj?.rmid !== null &&
          reqObj?.rmid !== undefined
        ) {
          if (
            !(
              responseObj.isprofiledetailscompleted &&
              responseObj.ispersonaldetailscompleted
            )
          ) {
          }
          GlobalStore.nextIncompleteStage = dashboardUrl.profile;
        }

        if (responseObj.iskyc) GlobalStore.isKYC = true;

        if (!(responseObj.isprofiledetailscompleted && responseObj.ispersonaldetailscompleted)) {
          GlobalStore.nextIncompleteStage = dashboardUrl.profile;
        }
        else if (!responseObj.isbankdetailscompleted) {
          GlobalStore.nextIncompleteStage = dashboardUrl.bank;
        }
        else if (responseObj?.accountcategory === 2 && !responseObj?.isdpcompleted)
          GlobalStore.nextIncompleteStage = dashboardUrl.demat;
        else if (!isUploadDocumentsCompleted)
          GlobalStore.nextIncompleteStage = dashboardUrl.doc;
        else if (responseObj.applicationstatus === 1 && responseObj.bpm_pd_status === 0)
          // history.push(statusUrl.docVerificationInProgress);
          navigate(statusUrl.docVerificationInProgress)
        else if (responseObj.bpm_pd_status === 1)
          // history.push(containerUrl.poa);
          navigate(containerUrl.poa)
        let newReqObj = reqObj;
        newReqObj.isKra = responseObj.iskra;
        if (!isUploadDocumentsCompleted && responseObj.bpm_pd_status === 2) {
          // history.push(statusUrl.documentReject);
          navigate(statusUrl.documentReject)
          return;
        }
        else if (
          isUploadDocumentsCompleted == true &&
          responseObj.bpm_pd_status === 2
        ) {
          QCServiceTaskCreation(
            (res: any) => {
              if (!res || res.error) {
                setIsLoading(false);
                setErrCode(res.error);
              } else {
                if (
                  res &&
                  res.data !== null &&
                  Object.keys(res?.data)?.length > 0
                ) {
                  // history.push(statusUrl.docVerificationInProgress);
                  navigate(statusUrl.docVerificationInProgress)
                  return
                } else {
                  setErrCode("Something went wrong. please try again later.");
                  setIsLoading(false);
                }
              }
            },
            GlobalStore?.applicationID,
            GlobalStore.stageStatus.accountcategory
              ? GlobalStore?.stageStatus?.accountcategory
              : 0
          );
        }
        if (
          reqObj?.skipUrlBoolean &&
          reqObj?.rmid !== null &&
          reqObj?.rmid !== undefined &&
          responseObj.applicationstatus === 1 &&
          responseObj.bpm_pd_status === 0
        ) {
          // history.push(statusUrl.docVerificationInProgress);
          navigate(statusUrl.docVerificationInProgress)
        } else if (
          reqObj?.skipUrlBoolean &&
          reqObj?.rmid !== null &&
          reqObj?.rmid !== undefined &&
          responseObj.applicationstatus === 1 &&
          responseObj.bpm_pd_status === 1
        ) {
          if (
            responseObj.isesigncompleted !== null &&
            responseObj.isesigncompleted == true &&
            responseObj?.auth_ver &&
            responseObj?.accountcategory === 2 &&
            responseObj?.elog_opted &&
            responseObj.isKra
          ) {
            // history.push(statusUrl.elogVerificationInProgress);
            navigate(statusUrl.elogVerificationInProgress)
          } else if (
            responseObj.isesigncompleted !== null &&
            responseObj.isesigncompleted == true &&
            responseObj?.auth_ver &&
            responseObj?.accountcategory === 2
          ) {
            // history.push(containerUrl.esignsubmit);
            navigate(containerUrl.esignsubmit)
          } else {
            if (
              responseObj.iskra !== null &&
              responseObj.iskra !== undefined &&
              responseObj?.auth_ver
            ) {
              navigate(containerUrl.kycsubmit)
            } else navigate(containerUrl.kycsubmit)
          }
        } else savePanDob(true, true, newReqObj);
      } else {
        if (errCode?.includes(res.error)) {
          setErrCode(errCode);
        } else {
          setErrCode(errCode + res.error);
        }
        setIsLoading(false);
      }
    }
  }

  const AgetClientDetailsByPANNew = (reqObj: any, newReqObj?: any) => {
    AGetClientDetailsByPan(
      (res: any) => {
        if (!res || res.error) {
          if (errCode?.includes(res.error)) {
            setErrCode(errCode);
          }
          else {
            setErrCode(errCode + res.error);
          }
          gtmService({
            action: "GetClientDataByPanOrLead",
            label: "ERROR || ERR102",
          });
          setIsLoading(false);
        } else {
          if (res.data !== null) {
            if (res.data !== null && res.data != "Records Not Found") {
              GlobalStore.personaldetails.pan = res.data.PAN;
              GlobalStore.token = res.data.Token;
              GlobalStore.applicationID = res.data.ApplicatoinId;
              GlobalStore.leadId = res.data.LeadId;
              GlobalStore.accountcategory = res.AccountCategory;
              GlobalStore.clientPrimaryDetailId =
                res.data.ClientPrimaryDetailId;
              const clientPartialDetails_ao = JSON.parse(
                window.localStorage.getItem("clientPartialDetails_ao") || "{}"
              );
              clientPartialDetails_ao.pan = res.data.Token;
              clientPartialDetails_ao.clientPrimaryDetailId =
                res.ClientPrimaryDetailId;
              clientPartialDetails_ao.applicationId = res.ApplicatoinId;
              clientPartialDetails_ao.accountcategory = res.AccountCategory;
              clientPartialDetails_ao.token = res.data.Token;
              window.localStorage.setItem(
                "clientPartialDetails_ao",
                JSON.stringify(clientPartialDetails_ao)
              );
              APendingUploadList((res: any) => {
                checkPendingUploadNew(res, newReqObj);
              }, GlobalStore.applicationID);
            }
          } else {
            // setErrCode('1182 - Error in fetching Client details from our system.');
            if (errCode?.includes(res.error)) {
              setErrCode(errCode);
            } else {
              setErrCode(errCode + res.error);
            }
            setIsLoading(false);
          }
        }
      },
      reqObj.pan,
      reqObj.accountType,
      reqObj.rmId
    );
  };

  const validatePANNew = (
    seedingStatus?: string,
    SeedingStatusMsg?: string,
    PanStatus?: string
  ) => {
    let PANFirstName = values?.firstName;
    let PANMiddleName = values.middleName ?? "";
    let PANlastName = values?.lastName ?? "";

    if (PANFirstName === "" && PANlastName !== "") {
      PANFirstName = PANlastName;
      GlobalStore.personaldetails.PANName = PANFirstName;
      PANlastName = "";
      if (PANMiddleName !== "") {
        GlobalStore.personaldetails.PANName =
          GlobalStore.personaldetails.PANName + " " + PANMiddleName;
      }
    } else if (
      PANFirstName === "" &&
      PANMiddleName === "" &&
      PANlastName === ""
    ) {
      GlobalStore.personaldetails.PANName = "";
    } else if (PANMiddleName === "") {
      GlobalStore.personaldetails.PANName = PANFirstName + " " + PANlastName;
      PANMiddleName = "";
    } else {
      GlobalStore.personaldetails.PANName =
        PANFirstName + " " + PANMiddleName + " " + PANlastName;
    }
    GlobalStore.personaldetails.firstname = PANFirstName;
    GlobalStore.personaldetails.lastname = PANlastName;
    GlobalStore.personaldetails.middlename = PANMiddleName;
    if (seedingStatus === "N") {
      GlobalStore.isSeeding = false;
    } else {
      GlobalStore.isSeeding = true;
    }
    let accountType = getProductCode() == "I" ? 2 : 1;
    if (getProductCode() == "I") {
      accountType = 2;
    }
    AGetClientDetailsByPan(
      searchByPan,
      values.pan,
      accountType,
      skipUrlBoolean &&
        prodObj?.createdBy != null &&
        prodObj?.createdBy !== undefined
        ? prodObj?.createdBy
        : GlobalStore?.user?.userId
    );
  };

  function searchByPan(res: any) {
    if (!res || res.error) {
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res.error);
      }
      gtmService({
        action: "GetClientDataByPanOrLead",
        label: "ERROR || ERR102",
      });
      setIsLoading(false);
    } else {
      if (res.data !== null) {
        if (res.data !== null && res.data != "Records Not Found") {
          GlobalStore.personaldetails.pan = res.data.PAN;
          GlobalStore.token = res.data.Token;
          GlobalStore.applicationID = res.data.ApplicatoinId;
          GlobalStore.leadId = res.data.LeadId;
          GlobalStore.clientPrimaryDetailId = res.data.ClientPrimaryDetailId;
          GlobalStore.accountcategory = res.AccountCategory;
          APendingUploadList(checkPendingUpload, GlobalStore.applicationID);
        } else {
          savePanDob();
        }
      } else if (res.data === null) {
        savePanDob();
      } else {
        if (errCode?.includes(res.error)) {
          setErrCode(errCode);
        } else {
          setErrCode(errCode + res.error);
        }
        setIsLoading(false);
      }
    }
  }

  const cacheKRAFunction = (
    responseObj: any,
    skipSavePANDOB?: boolean,
    reqObj?: any
  ) => {
    GlobalStore.isKRA = true;
    if (applicationModeType !== "isKRA") {
      setApplicationModeType("isKRA");
    }
    const clientPartialDetails_ao = JSON.parse(
      window.localStorage.getItem("clientPartialDetails_ao") || "{}"
    );
    GlobalStore.KRA_email = responseObj.KraEmail ? responseObj.KraEmail : "";
    GlobalStore.KRA_mobile = responseObj.KraMobile ? responseObj.KraMobile : "";
    GlobalStore.KRA_mode = responseObj.kra_mode ? responseObj.kra_mode : 0;

    // if (!GlobalStore.isKYC) {
    const resultObj = responseObj;
    GlobalStore.kraInfoObject.addressLine1 = `${resultObj.AppPerAdd1} ${resultObj.AppPerAdd2 || ""
      } ${resultObj.AppPerAdd3 || ""}`;
    GlobalStore.kraInfoObject.addressLine1 =
      GlobalStore.kraInfoObject.addressLine1; //.replace(/[^a-zA-Z0-9 ]/g, " ")

    GlobalStore.kraInfoObject.corrAddress = `${resultObj.AppCorAdd1} ${resultObj.AppCorAdd2 || ""
      } ${resultObj.AppCorAdd3 || ""}`;
    GlobalStore.kraInfoObject.corrAddress =
      GlobalStore.kraInfoObject.corrAddress; //.replace(/[^a-zA-Z0-9 ]/g, " ")
    GlobalStore.kraInfoObject.pincode = resultObj.AppPerPincd;
    GlobalStore.kraInfoObject.corrPincode = resultObj.AppCorPincd;
    GlobalStore.personaldetails.fsfullName = resultObj.FatherName
      ? resultObj.FatherName
      : GlobalStore.personaldetails.fsfullName;
    clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
    clientPartialDetails_ao.gender = responseObj?.Gender;
    GlobalStore.personaldetails.gender = responseObj?.Gender;
    clientPartialDetails_ao.addressLine1 =
      GlobalStore.kraInfoObject.addressLine1;
    clientPartialDetails_ao.PinCode = GlobalStore.kraInfoObject.pincode;
    clientPartialDetails_ao.corrAddress = GlobalStore.kraInfoObject.corrAddress;
    clientPartialDetails_ao.corrPincode = GlobalStore.kraInfoObject.corrPincode;
    clientPartialDetails_ao.fsfullName = GlobalStore.personaldetails.fsfullName;
    clientPartialDetails_ao.sameAsPermanent =
      GlobalStore.kraInfoObject.addressLine1 ==
        GlobalStore.kraInfoObject.corrAddress
        ? true
        : false;
    // } else {
    //     clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
    // }'
    if (skipSavePANDOB) {
      clientPartialDetails_ao.pan = GlobalStore?.personaldetails.pan;
      clientPartialDetails_ao.clientPrimaryDetailId =
        GlobalStore?.clientPrimaryDetailId;
      clientPartialDetails_ao.applicationId = GlobalStore.applicationID;
      clientPartialDetails_ao.accountcategory = GlobalStore?.accountcategory;
      clientPartialDetails_ao.token = GlobalStore?.token;
      clientPartialDetails_ao.leadID = GlobalStore.leadId;
    }
    window.localStorage.setItem(
      "clientPartialDetails_ao",
      JSON.stringify(clientPartialDetails_ao)
    );
    GlobalStore.dateofbirth = moment(values.dob).format("MM/DD/YYYY");
    GlobalStore.dateOfIncorporation = moment(values.dob).format("YYYY-MM-DD");
    if (skipSavePANDOB) {
      menuOption(reqObj, () => {
        // history.push(dashboardUrl.profile);
        navigate(dashboardUrl.profile)
      });
    } else dobMatched({}, true, true);
  };

  const menuOption = (reqObj?: any, redirctTo?: Function) => {
    if (
      reqObj.skipUrlBoolean &&
      reqObj?.rmid !== null &&
      reqObj?.rmid !== undefined
    ) {
      if (!reqObj?.isKra || !isPanLinkedToAadharRef.current) {
        let filterLeftBar = [...leftNavBarArray];
        let filterNavIndex = filterLeftBar?.findIndex(
          (filter) => filter?.navUrl == "/plan"
        );
        if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex, 1);
        let filterNavIndex2 = filterLeftBar?.findIndex(
          (filter) => filter?.navUrl == dashboardUrl.eSign
        );
        if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex2, 1);
        let filterNavIndex3 = filterLeftBar?.findIndex(
          (filter) => filter?.navUrl == dashboardUrl.profiler
        );
        if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex3, 1);
        let filterNavIndex4 = filterLeftBar?.findIndex(
          (filter) => filter?.navUrl == dashboardUrl.ipv
        );
        if (filterNavIndex4 > 0) filterLeftBar?.splice(filterNavIndex4, 1);
        if (!hasNavBarEntry(filterLeftBar, dematNavBarObj.navUrl))
          filterLeftBar.push(dematNavBarObj);
        // GlobalStore.leftNavBarState = filterLeftBar;
      } else {
        setDobChecked(true);
        let filterLeftBar = [...leftNavBarArray];
        let filterNavIndex = filterLeftBar?.findIndex(
          (filter) => filter?.navUrl == "/plan"
        );
        if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex, 1);
        let filterNavIndex2 = filterLeftBar?.findIndex(
          (filter) => filter?.navUrl == dashboardUrl.eSign
        );
        if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex2, 1);
        let filterNavIndex3 = filterLeftBar?.findIndex(
          (filter) => filter?.navUrl == dashboardUrl.profiler
        );
        if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex3, 1);
        let filterNavIndex4 = filterLeftBar?.findIndex(
          (filter) => filter?.navUrl == dashboardUrl.ipv
        );
        if (filterNavIndex4 > 0) filterLeftBar?.splice(filterNavIndex4, 1);
        if (!hasNavBarEntry(filterLeftBar, dematNavBarObj.navUrl))
          filterLeftBar.push(dematNavBarObj);
        // GlobalStore.leftNavBarState = filterLeftBar;
      }
      if (redirctTo !== undefined) redirctTo();
    }
  };

  const originalSavePANDOB = (
    applicationIdExists?: boolean,
    skipSavePANDOB?: boolean,
    reqObj?: any
  ) => {
    if (
      applicationIdExists &&
      (GlobalStore.stageStatus.ispersonaldetailscompleted ||
        GlobalStore.stageStatus.isprofiledetailscompleted)
    ) {
      const clientPartialDetails_ao = JSON.parse(
        window.localStorage.getItem("clientPartialDetails_ao") || "{}"
      );

      clientPartialDetails_ao.PANName = GlobalStore.personaldetails.PANName;
      clientPartialDetails_ao.aadharLinkedChoice =
        GlobalStore.aadharLinkedChoice;
      clientPartialDetails_ao.applicationId = GlobalStore.applicationID;
      clientPartialDetails_ao.birthDate = GlobalStore.birthDate;
      clientPartialDetails_ao.ckycNo = GlobalStore.stageStatus.ckycnumber;
      clientPartialDetails_ao.clientPrimaryDetailId =
        GlobalStore.clientPrimaryDetailId;
      clientPartialDetails_ao.dob = GlobalStore.dob;
      clientPartialDetails_ao.dateOfIncorporation = GlobalStore.dateOfIncorporation;
      clientPartialDetails_ao.emailID = GlobalStore.user.email;
      clientPartialDetails_ao.isDigiLocker = GlobalStore.isDigiLocker;
      clientPartialDetails_ao.isKRA = GlobalStore.stageStatus.iskra;
      clientPartialDetails_ao.isKYC = GlobalStore.stageStatus.iskyc;

      clientPartialDetails_ao.isSeniorCitizen =
        window.sessionStorage.getItem("isSeniorCitizen") === "true"
          ? true
          : false;
      clientPartialDetails_ao.leadID = GlobalStore.leadId;
      clientPartialDetails_ao.mobile = GlobalStore.user.mobile;
      clientPartialDetails_ao.pan = values.pan || values.gurdianPanNo;
      clientPartialDetails_ao.panDetails =
        GlobalStore.personaldetails.panDetails;
      clientPartialDetails_ao.token = GlobalStore.token;
      clientPartialDetails_ao.isSeeding = GlobalStore.isSeeding;
      // if(GlobalStore?.applicationID && GlobalStore?.isDigiLocker){
      //   setShowSubmitModal(true);
      // }
      window.localStorage.setItem(
        "clientPartialDetails_ao",
        JSON.stringify(clientPartialDetails_ao)
      );
      registerCleverTapEventAfterProceed();
      gtmService({ action: "PAN_DOB", label: "Step_Complete" });
      if (GlobalStore?.applicationID && GlobalStore?.isDigiLocker) {
        // history.push(GlobalStore?.nextIncompleteStage);
        navigate(GlobalStore?.nextIncompleteStage)
      } else {
        if (skipSavePANDOB) {
          menuOption(reqObj, () => {
            navigateTo(applicationIdExists, reqObj);
          });
        } else navigateTo(applicationIdExists);
      }
    } else {
      GlobalStore.dateofbirth = moment(values.dob).format("MM/DD/YYYY");
      GlobalStore.dob = moment(values.dob).format("DD/MM/YYYY");
      GlobalStore.dateOfIncorporation = moment(values.dob).format("YYYY-MM-DD");
      GlobalStore.birthDate = moment(values.dob).format("MM/DD/YYYY");
      if (skipSavePANDOB) {
        let clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        clientPartialDetails_ao = {
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId,
          token: GlobalStore.token,
          applicationId: GlobalStore.applicationID,
          dob: GlobalStore.dob,
          dateOfIncorporation: GlobalStore.dateOfIncorporation,
          birthDate: GlobalStore.birthDate,
          pan: values.pan,
          aadharLinkedChoice: GlobalStore.aadharLinkedChoice,
          leadID: GlobalStore.leadId,
          emailID: GlobalStore.user.email,
          mobile: GlobalStore.user.mobile,
          panDetails: GlobalStore.personaldetails.panDetails,
          PANName: GlobalStore.personaldetails.PANName,
          isSeniorCitizen:
            window.sessionStorage.getItem("isSeniorCitizen") === "true"
              ? true
              : false,
          isDigiLocker: GlobalStore.isDigiLocker,
          isKRA: false,
          isKYC: false,
          isSeeding: GlobalStore.isSeeding,
          selfieUrl: GlobalStore.selfieUrl,
          isManual: false,
          aadharNo: GlobalStore.personaldetails.aadharNo,
          addressLine1: GlobalStore.addressLine1,
          corrAddress: GlobalStore.corrAddress,
          PinCode: GlobalStore.PinCode,
          corrPincode: GlobalStore.corrPincode,
          sameAsPermanent: GlobalStore.sameAsPermanent,
        };
        window.localStorage.setItem(
          "aadharNumber",
          GlobalStore.personaldetails.aadharNo
        );
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        if (
          reqObj.skipUrlBoolean &&
          reqObj?.rmid !== null &&
          reqObj?.rmid !== undefined
        ) {
          if (!reqObj?.isKra || !isPanLinkedToAadharRef.current) {
            let filterLeftBar = [...leftNavBarArray];
            let filterNavIndex = filterLeftBar?.findIndex(
              (filter) => filter?.navUrl == "/plan"
            );
            if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex, 1);
            let filterNavIndex2 = filterLeftBar?.findIndex(
              (filter) => filter?.navUrl == dashboardUrl.eSign
            );
            if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex2, 1);
            let filterNavIndex3 = filterLeftBar?.findIndex(
              (filter) => filter?.navUrl == dashboardUrl.profiler
            );
            if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex3, 1);
            let filterNavIndex4 = filterLeftBar?.findIndex(
              (filter) => filter?.navUrl == dashboardUrl.ipv
            );
            if (filterNavIndex4 > 0) filterLeftBar?.splice(filterNavIndex4, 1);
            if (!hasNavBarEntry(filterLeftBar, dematNavBarObj.navUrl))
              filterLeftBar.push(dematNavBarObj);
            // GlobalStore.leftNavBarState = filterLeftBar;
          } else {
            //  setShowSubmitModal(true);
            setDobChecked(true);
            // if (applicationModeType !== "isKRA") {
            //   setApplicationModeType("isKRA");
            // }
            let filterLeftBar = [...leftNavBarArray];
            let filterNavIndex = filterLeftBar?.findIndex(
              (filter) => filter?.navUrl == "/plan"
            );
            if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex, 1);
            let filterNavIndex2 = filterLeftBar?.findIndex(
              (filter) => filter?.navUrl == dashboardUrl.eSign
            );
            if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex2, 1);
            let filterNavIndex3 = filterLeftBar?.findIndex(
              (filter) => filter?.navUrl == dashboardUrl.profiler
            );
            if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex3, 1);
            let filterNavIndex4 = filterLeftBar?.findIndex(
              (filter) => filter?.navUrl == dashboardUrl.ipv
            );
            if (filterNavIndex4 > 0) filterLeftBar?.splice(filterNavIndex4, 1);
            if (!hasNavBarEntry(filterLeftBar, dematNavBarObj.navUrl))
              filterLeftBar.push(dematNavBarObj);
            // GlobalStore.leftNavBarState = filterLeftBar;
          }
        }
        // if (!(objAccType === 'RMINV' && !GlobalStore.isKRA)) {
        setShowSubmitModal(true);
        // }
        navigateTo(applicationIdExists, reqObj);
      } else {
        if (isPanLinkedToAadharRef.current) {
          dobMatched({});
        } else {
          GlobalStore.isKYC = false;
          GlobalStore.isKRA = false;
          const clientPartialDetails_ao = JSON.parse(
            window.localStorage.getItem("clientPartialDetails_ao") || "{}"
          );
          clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
          clientPartialDetails_ao.isKYC = GlobalStore.isKYC;
          window.localStorage.setItem(
            "clientPartialDetails_ao",
            JSON.stringify(clientPartialDetails_ao)
          );
          dobMatched({});
        }
      }
    }
  };

  function savePanDob(
    applicationIdExists?: boolean,
    skipSavePANDOB?: boolean,
    reqObj?: any
  ) {
    if (
      GlobalStore?.applicationID &&
      GlobalStore.stageStatus.ispersonaldetailscompleted !== true &&
      GlobalStore.stageStatus.isprofiledetailscompleted !== true
    ) {
      AGetCacheData(
        (res: any) => {
          if (
            res &&
            res.data &&
            res?.data?.Result &&
            res?.data?.Result.IsTaggingPresent
          ) {
            let cacheResponse = res?.data?.Result;
            if (
              GlobalStore?.applicationID &&
              GlobalStore.stageStatus.ispersonaldetailscompleted !== true &&
              GlobalStore.stageStatus.isprofiledetailscompleted !== true &&
              cacheResponse !== null &&
              cacheResponse?.IsTaggingPresent
            ) {
              if (cacheResponse?.TaggingMode == "1") {
                cacheKRAFunction(cacheResponse?.Data, skipSavePANDOB, reqObj);
              } else if (cacheResponse?.TaggingMode == "2") {
                GlobalStore.isDigiLocker = true;

                const clientPartialDetails_ao = JSON.parse(
                  window.localStorage.getItem("clientPartialDetails_ao") || "{}"
                );
                clientPartialDetails_ao.PANName =
                  GlobalStore.personaldetails.PANName;
                clientPartialDetails_ao.aadharLinkedChoice =
                  GlobalStore.aadharLinkedChoice;
                clientPartialDetails_ao.applicationId =
                  GlobalStore.applicationID;
                clientPartialDetails_ao.birthDate = GlobalStore.birthDate;
                clientPartialDetails_ao.ckycNo =
                  GlobalStore.stageStatus.ckycnumber;
                clientPartialDetails_ao.clientPrimaryDetailId =
                  GlobalStore.clientPrimaryDetailId;
                clientPartialDetails_ao.dob = GlobalStore.dob;
                clientPartialDetails_ao.dateOfIncorporation = GlobalStore.dateOfIncorporation;
                clientPartialDetails_ao.emailID = GlobalStore.user.email;
                clientPartialDetails_ao.isDigiLocker = GlobalStore.isDigiLocker;
                clientPartialDetails_ao.isKRA = GlobalStore.stageStatus.iskra;
                clientPartialDetails_ao.isKYC = GlobalStore.stageStatus.iskyc;

                clientPartialDetails_ao.isSeniorCitizen =
                  window.sessionStorage.getItem("isSeniorCitizen") === "true"
                    ? true
                    : false;
                clientPartialDetails_ao.leadID = GlobalStore.leadId;
                clientPartialDetails_ao.mobile = GlobalStore.user.mobile;
                clientPartialDetails_ao.pan = values.pan;
                clientPartialDetails_ao.panDetails =
                  GlobalStore.personaldetails.panDetails;
                clientPartialDetails_ao.token = GlobalStore.token;
                clientPartialDetails_ao.isSeeding = GlobalStore.isSeeding;
                clientPartialDetails_ao.signzydt = "";

                window.localStorage.setItem(
                  "clientPartialDetails_ao",
                  JSON.stringify(clientPartialDetails_ao)
                );
                getProfileDetailsFromAadhar(cacheResponse?.Data);
                if (skipSavePANDOB) menuOption();
                // history.push(dashboardUrl.profile);
                navigate(dashboardUrl.profile)
              } else if (cacheResponse?.TaggingMode == "3") {
                GlobalStore.isNormalClient = true;
                GlobalStore.isKYC = false;
                GlobalStore.isKRA = false;
                const clientPartialDetails_ao = JSON.parse(
                  window.localStorage.getItem("clientPartialDetails_ao") || "{}"
                );
                clientPartialDetails_ao.PANName =
                  GlobalStore.personaldetails.PANName;
                clientPartialDetails_ao.aadharLinkedChoice =
                  GlobalStore.aadharLinkedChoice;
                clientPartialDetails_ao.applicationId =
                  GlobalStore.applicationID;
                clientPartialDetails_ao.birthDate = GlobalStore.birthDate;
                clientPartialDetails_ao.ckycNo =
                  GlobalStore.stageStatus.ckycnumber;
                clientPartialDetails_ao.clientPrimaryDetailId =
                  GlobalStore.clientPrimaryDetailId;
                clientPartialDetails_ao.dob = GlobalStore.dob;
                clientPartialDetails_ao.dateOfIncorporation = GlobalStore.dateOfIncorporation;
                clientPartialDetails_ao.emailID = GlobalStore.user.email;
                clientPartialDetails_ao.isDigiLocker = GlobalStore.isDigiLocker;
                clientPartialDetails_ao.addressLine1 =
                  cacheResponse?.Data.PermanentAddressDetails.PermanentAddressLine1;
                clientPartialDetails_ao.addressLine1 +=
                  cacheResponse?.Data.PermanentAddressDetails.PermanentAddressLine2;
                clientPartialDetails_ao.addressLine1 +=
                  cacheResponse?.Data.PermanentAddressDetails.PermanentAddressLine3;
                clientPartialDetails_ao.addressLine1 +=
                  cacheResponse?.Data.PermanentAddressDetails.PermanentAddressLine4;
                clientPartialDetails_ao.sameAsPermanent =
                  cacheResponse?.Data.corrsaddraspermanent !== null &&
                    cacheResponse?.Data.corrsaddraspermanent !== undefined
                    ? cacheResponse?.Data.corrsaddraspermanent
                    : true;
                clientPartialDetails_ao.corrAddress =
                  cacheResponse?.Data.CorrespondenceAddressDetails.CorrespondenceAddressLine1;
                clientPartialDetails_ao.corrAddress +=
                  cacheResponse?.Data.CorrespondenceAddressDetails.CorrespondenceAddressLine2;
                clientPartialDetails_ao.corrAddress +=
                  cacheResponse?.Data.CorrespondenceAddressDetails.CorrespondenceAddressLine3;
                clientPartialDetails_ao.corrAddress +=
                  cacheResponse?.Data.CorrespondenceAddressDetails.CorrespondenceAddressLine4;
                GlobalStore.addressLine1 = clientPartialDetails_ao.addressLine1;
                GlobalStore.corrAddress = clientPartialDetails_ao.corrAddress;
                GlobalStore.PinCode =
                  cacheResponse?.Data.PermanentAddressDetails.PermanentPincode;
                GlobalStore.corrPincode =
                  cacheResponse?.Data.CorrespondenceAddressDetails.CorrespondencePincode;
                GlobalStore.sameAsPermanent =
                  cacheResponse?.Data.corrsaddraspermanent !== null &&
                    cacheResponse?.Data.corrsaddraspermanent !== undefined
                    ? cacheResponse?.Data.corrsaddraspermanent
                    : true;
                clientPartialDetails_ao.isSeniorCitizen =
                  window.sessionStorage.getItem("isSeniorCitizen") === "true"
                    ? true
                    : false;
                clientPartialDetails_ao.PinCode =
                  cacheResponse?.Data.PermanentAddressDetails.PermanentPincode;
                clientPartialDetails_ao.corrPincode =
                  cacheResponse?.Data.CorrespondenceAddressDetails.CorrespondencePincode;
                clientPartialDetails_ao.leadID = GlobalStore.leadId;
                clientPartialDetails_ao.mobile = GlobalStore.user.mobile;
                clientPartialDetails_ao.pan = values.pan;
                clientPartialDetails_ao.panDetails =
                  GlobalStore.personaldetails.panDetails;
                clientPartialDetails_ao.token = GlobalStore.token;
                clientPartialDetails_ao.isSeeding = GlobalStore.isSeeding;
                clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
                clientPartialDetails_ao.isKYC = GlobalStore.isKYC;
                clientPartialDetails_ao.isNormalClient =
                  GlobalStore.isNormalClient;
                window.localStorage.setItem(
                  "clientPartialDetails_ao",
                  JSON.stringify(clientPartialDetails_ao)
                );
                if (skipSavePANDOB) menuOption();
                // history.push(dashboardUrl.profile);
                navigate(dashboardUrl.profile)
              }
            } else {
              originalSavePANDOB(applicationIdExists, skipSavePANDOB, reqObj);
            }
            setCacheResponse(res?.data);
          } else {
            originalSavePANDOB(applicationIdExists, skipSavePANDOB, reqObj);
            setCacheResponse(null);
          }
        },
        {
          uniqueID: GlobalStore?.applicationID,
          key: `AOPDROPOFF-${GlobalStore?.applicationID}`,
        }
      );
    } else {
      originalSavePANDOB(applicationIdExists, skipSavePANDOB, reqObj);
    }
  }

  const kraDobCheckNew = (res: any, applicationIdExists?: boolean) => {
    if (!res || res.error) {
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res.error);
      }
      gtmService({ action: "GetKraDetails", label: "ERROR || ERR108" });
      navigateTo(applicationIdExists);
    } else {
      const responseObj = res.data;
      if (responseObj?.DOB) {
        let dobValue = responseObj.DOB;
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(dobValue)) {
          const [day, month, year] = dobValue.split("/");
          dobValue = new Date(`${year}-${month}-${day}`);
        }
        if (ageCalculator(dobValue) >= 60) {
          window.sessionStorage.setItem("isSeniorCitizen", "true");
        }
      }

      if (responseObj?.AppErrorDesc?.includes("INVALID DOB")) {
        setIsLoading(false);
        setErrCode(errCode ? errCode : "" + (res.error || ""));
        setErrors({ ...errors, dob: errorMsg(errorCode.FE11) });
      } else {
        getKraDetails(responseObj, applicationIdExists);
      }
    }
  };

  const getProductCode = () => {
    let productCodeNew: string = "";
    if (
      GlobalStore?.user?.accountType !== null &&
      GlobalStore?.user?.accountType !== undefined &&
      GlobalStore?.user?.accountType !== ""
    ) {
      productCodeNew = GlobalStore?.user?.accountType;
    } else {
      const objAccType = window.sessionStorage.getItem("objAccType");
      if (
        localProductCode !== null &&
        localProductCode !== undefined &&
        localProductCode !== "" &&
        localProductCode?.length > 0
      ) {
        productCodeNew = localProductCode;
      } else {
        if (objAccType === "DMT") {
          productCodeNew = "D";
        } else if (objAccType === "RMINV") {
          productCodeNew = "I";
        } else {
          productCodeNew = "TD";
        }
      }
    }
    return productCodeNew;
  };

  const getAccountCategory = () => {
    let accountCategory = null;
    if (getProductCode() == "I") {
      accountCategory = 2;
    } else {
      accountCategory = 1;
    }
    return accountCategory;
  };

  function dobMatched(
    kycobj: any,
    applicationIdExists?: boolean,
    cacheResonse?: boolean
  ) {
    let objAccType = window.sessionStorage.getItem("objAccType") || "";
    const objUtm = JSON.parse(
      window.sessionStorage.getItem("objUTM_Info") || "{}"
    );
    const modifiedBy = window.sessionStorage.getItem('empCode')
    const panDobObjExistingFields = {
      leadId: GlobalStore.leadId,
      emailID: GlobalStore.user.email,
      mobileno: GlobalStore.user.mobile,
      isemployeepan: isEmployee,
      panNo: values.pan,
      dob: GlobalStore.dateofbirth,
      product: getProductCode(),
      platform: 1,
      panFName: values?.firstName,
      panMName: values?.middleName,
      panLName: values?.lastName,
      PanFSName: values.fatherName,
      SendSelfieLink: togPhoto,
      diyReferralLink: localURL,
      accountCategory: getAccountCategory() !== null ? getAccountCategory() : 0,
      createdBy:
        objAccType === "RMINV"
          ? (objUtm?.utmsource || objUtm?.utm_source) === "PARTNER"
            ? objUtm?.AssignedTo
            : objUtm?.utm_campaign
          : skipUrlBoolean && !!prodObj?.createdBy && prodObj?.createdBy
            ? parseInt(prodObj?.createdBy)
            : 0,
      rmAssisted: objAccType === "RMINV" ? true :
        skipUrlBoolean && !!prodObj?.createdBy && prodObj?.createdBy
          ? true
          : false,
      entityType: entityType || "",
      entitySubType: entitySubType || "",
      gurdianPanNo: values?.gurdianPanNo,
      gurdianDOB: entityType !== "Minor" ? null : moment(values?.gurdianDOB).format("DD/MM/YYYY"),
      gurdianFName: values?.gurdianFName,
      gurdianMName: values?.gurdianMName,
      gurdianLName: values?.gurdianLName,
      accountTypeName: SUBTYPE_MAP[GlobalStore.entitySubType] || null,
      panCompFirmName: values.fullname || "",
      ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
    };

    const jointHolderDetails = buildJointHolderDetails(accHolders, relationShipList);

    const panDobObj = {
      ...panDobObjExistingFields,
      jointHolderDetails
    };

    ASavePanDobDetailsJoint(
      (res: any) =>
        applicationInitialized(res, kycobj, applicationIdExists, cacheResonse),
      panDobObj
    );
  }

  function applicationInitialized(
    res: any,
    kycobj: any,
    applicationIdExists?: boolean,
    cacheResponse?: boolean
  ) {
    if (!res || res.error) {
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res.error);
      }
      gtmService({ action: "SavePanDobDetails", label: "ERROR || ERR106" });
      setIsLoading(false);
    } else {
      if (res.data && res.data.LeadId) {
        GlobalStore.leadId = res.data.LeadId;
        GlobalStore.token = res.data.Token;
        GlobalStore.applicationID = res.data.ApplicationID;
        GlobalStore.clientPrimaryDetailId = res.data.ClientPrimaryDetailId;
        GlobalStore.aadharLinkedChoice =
          values.aadharLinked === "Yes" ? true : false;
        GlobalStore.personaldetails.pan = values.pan || values.gurdianPanNo;
        //  GlobalStore.personaldetails.aadharNo = values.aadhaarNo.slice(-4);
        // Create link for capturing selfie from mobile
        let AccountObj = {
          PanNo: values?.pan,
          AccountCategory: getProductCode() == "I" ? 2 : 1,
          userid: prodObj?.createdBy,
        };
        let accountObjString = JSON.stringify(AccountObj);
        const encodedPan = btoa(accountObjString);
        let stringParams = `selfie?id=${encodedPan}`;

        const selfieUrl = `${config.root}${stringParams}`;
        GlobalStore.selfieUrl = selfieUrl;
        const clientObj = {
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId,
          applicationId: GlobalStore.applicationID,
        };
        window.sessionStorage.setItem(
          "clientDetails",
          JSON.stringify(clientObj)
        );

        let filterLeftBar = leftNavBarArray;
        const allowedUrls = [
          dashboardUrl.profile,
          dashboardUrl.bank,
          dashboardUrl.doc,     // Verify Personal Documents
          dashboardUrl.plan,    // If "deemal" means plan
        ];

        filterLeftBar = leftNavBarArray.filter(item =>
          allowedUrls.includes(item.navUrl)
        );
        GlobalStore.setLeftNavBarState(filterLeftBar);
        const clientPartialDetails_ao = {
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId,
          token: GlobalStore.token,
          applicationId: GlobalStore.applicationID,
          dob: GlobalStore.dob,
          dateOfIncorporation: GlobalStore.dateOfIncorporation,
          birthDate: GlobalStore.birthDate,
          pan: values.pan || values.gurdianPanNo,
          aadharLinkedChoice: GlobalStore.aadharLinkedChoice,
          leadID: GlobalStore.leadId,
          emailID: GlobalStore.user.email,
          mobile: GlobalStore.user.mobile,
          panDetails: GlobalStore.personaldetails.panDetails,
          PANName: GlobalStore.personaldetails.PANName,
          isSeniorCitizen:
            window.sessionStorage.getItem("isSeniorCitizen") === "true"
              ? true
              : false,
          isDigiLocker: GlobalStore.isDigiLocker,
          isKRA: false,
          isKYC: false,
          isSeeding: GlobalStore.isSeeding,
          selfieUrl: GlobalStore.selfieUrl,
          isManual: false,
          aadharNo: GlobalStore.personaldetails.aadharNo,
          fsfullName: values?.fatherName,
        };
        window.localStorage.setItem(
          "aadharNumber",
          GlobalStore.personaldetails.aadharNo
        );
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        nextprocess(kycobj);
      } else {
        if (errCode?.includes(res.error)) {
          setErrCode(errCode);
        } else {
          setErrCode(errCode + res.error);
        }
        setIsLoading(false);
      }
    }
  }

  React.useEffect(() => {
    if (applicationInitializedFlag && applicationModeType === "isDigiLocker" && (!(objAccType === 'RMINV' && !GlobalStore.isKRA))) {
      setShowSubmitModal(true);
    }
  }, [applicationInitializedFlag, applicationModeType]);

  function checkPendingUpload(res: any) {
    if (!res || res.error) {
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res.error);
      }
      gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR112" });
      setIsLoading(false);
    } else {
      if (res && res?.data == null) {
        let isUploadDocumentsCompleted: boolean = false;
        AGetStageCompletionStatus(
          (res: any) => getClientStageDetails(res, isUploadDocumentsCompleted),
          GlobalStore.applicationID
        );
      } else if (res && res.data !== null) {
        const list: Array<any> = JSON.parse(res.data).filter(
          (item: any) =>
            item.Mandatory == true
        );
        let isUploadDocumentsCompleted: boolean = false;
        if (list.length === 0 || list[0].count === 0)
          isUploadDocumentsCompleted = true;
        const redisReqObj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailsId: GlobalStore.clientPrimaryDetailId,
        };
        AGetStageCompletionStatus(
          (res: any) => getClientStageDetails(res, isUploadDocumentsCompleted),
          GlobalStore.applicationID
        );
      } else {
        if (errCode?.includes(res.error)) {
          setErrCode(errCode);
        } else {
          setErrCode(errCode + res.error);
        }
        setIsLoading(false);
      }
    }
  }

  function getClientStageDetails(
    res: any,
    isUploadDocumentsCompleted: boolean
  ) {
    if (!res || res.error) {
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res.error);
      }
      gtmService({
        action: "GetStageCompletionStatus",
        label: "ERROR || ERR113",
      });
      setIsLoading(false);
    } else {
      if (res.data) {
        const responseObj = JSON.parse(res.data);
        GlobalStore.entityType = responseObj?.entitytype
        GlobalStore.entitySubType = responseObj?.entitysubtype
        setStageData(responseObj);
        checkModuleCompleteness(isUploadDocumentsCompleted);
        if (
          skipUrlBoolean &&
          prodObj?.createdBy !== null &&
          prodObj?.createdBy !== undefined
        ) {
          if (
            !(
              responseObj.isprofiledetailscompleted &&
              responseObj.ispersonaldetailscompleted
            )
          )
            GlobalStore.nextIncompleteStage = dashboardUrl.profile;
        } else {
          if (responseObj.isdigilockercompleted) {
            GlobalStore.isDigiLocker = true;
            setApplicationModeType("isDigiLocker");
          }
        }

        if (responseObj.iskra) {
          GlobalStore.isKRA = true;
          setApplicationModeType("isKRA");
        }
        if (responseObj.iskyc) GlobalStore.isKYC = true;
        if (!(responseObj.isprofiledetailscompleted && responseObj.ispersonaldetailscompleted))
          GlobalStore.nextIncompleteStage = dashboardUrl.profile;
        else if (!responseObj.isbankdetailscompleted) {
          GlobalStore.nextIncompleteStage = dashboardUrl.bank;
        }
        else if (responseObj?.accountcategory === 2 && !responseObj?.isdpcompleted)
          GlobalStore.nextIncompleteStage = dashboardUrl.demat;
        else if (
          responseObj?.accountcategory !== 2 &&
          (!responseObj.isbrokeragesegmentcompleted ||
            !responseObj.isbrokerageschemecompleted)
        )
          GlobalStore.nextIncompleteStage = dashboardUrl.plan;
        else if (!isUploadDocumentsCompleted)
          GlobalStore.nextIncompleteStage = dashboardUrl.doc;
        else if (
          !GlobalStore.isDigiLocker &&
          !GlobalStore.isKRA &&
          !GlobalStore.isKYC &&
          !responseObj.isipvarificationcompleted
        )
          GlobalStore.nextIncompleteStage = dashboardUrl.ipv;
        else if (responseObj.isagentvisitcompleted)
          GlobalStore.nextIncompleteStage = containerUrl.ocv;
        else if (
          skipUrlBoolean &&
          prodObj?.createdBy !== null &&
          prodObj?.createdBy !== undefined &&
          !responseObj.isesigncompleted &&
          responseObj?.accountcategory === 2
        ) {
          if (responseObj.bpm_pd_status === 0)
            // history.push(statusUrl.docVerificationInProgress);
            navigate(statusUrl.docVerificationInProgress)
          else if (responseObj.bpm_pd_status === 1)
            // history.push(containerUrl.poa);
            navigate(containerUrl.poa)
        } else if (!responseObj.isesigncompleted)
          GlobalStore.nextIncompleteStage = dashboardUrl.eSign;
        else if (responseObj.bpm_pd_status === 0)
          // history.push(statusUrl.docVerificationInProgress);
          navigate(statusUrl.docVerificationInProgress)
        else if (responseObj.bpm_pd_status === 1)
          // history.push(containerUrl.poa);
          navigate(containerUrl.poa)
        if (
          skipUrlBoolean &&
          prodObj?.createdBy !== null &&
          prodObj?.createdBy !== undefined &&
          !responseObj.isesigncompleted &&
          responseObj?.accountcategory === 2
        ) {
          if (responseObj.bpm_pd_status === 0)
            // history.push(statusUrl.docVerificationInProgress);
            navigate(statusUrl.docVerificationInProgress)
        } else {
          savePanDob(true);
        }
      } else {
        if (errCode?.includes(res.error)) {
          setErrCode(errCode);
        } else {
          setErrCode(errCode + res.error);
        }
        setIsLoading(false);
      }
    }
  }

  function getKraDetails(res: any, applicationIdExists?: boolean) {
    if (!res || res.error) {
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res.error);
      }
      gtmService({ action: "GetKraDetails", label: "ERROR || ERR108-1" });
      navigateTo(applicationIdExists);
    } else {
      const responseObj = res.data ? res.data : res;
      if (!responseObj.AppStatus || responseObj.AppStatus !== "07") {
        setIsLoading(false)
        setErrCode("Unable to fetch KRA details. Please try again later.");
        return
      }
      if (responseObj && responseObj.AppStatus === "07") {
        GlobalStore.isKRA = true;
        if (applicationModeType !== "isKRA") {
          setApplicationModeType("isKRA");
        }
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );

        GlobalStore.KRA_email = responseObj.KraEmail
          ? responseObj.KraEmail
          : "";
        GlobalStore.KRA_mobile = responseObj.KraMobile
          ? responseObj.KraMobile
          : "";
        GlobalStore.KRA_mode = responseObj.kra_mode ? responseObj.kra_mode : 0;
        if (getAccountCategory() == 2) {
          if (
            skipUrlBoolean &&
            prodObj?.createdBy !== null &&
            prodObj?.createdBy !== undefined
          ) {
          } else {
            let filterLeftBar = [...leftNavBarArray];
            let filterNavIndex1 = filterLeftBar?.findIndex(
              (filter) => filter?.navUrl == dashboardUrl.eSign
            );
            if (filterNavIndex1 > 0) filterLeftBar?.splice(filterNavIndex1, 1);
            if (!hasNavBarEntry(filterLeftBar, authenticateNavBarObj.navUrl))
              filterLeftBar.push(authenticateNavBarObj);
            // GlobalStore.leftNavBarState = filterLeftBar;
          }
        }

        // if (!GlobalStore.isKYC) {
        const resultObj = responseObj;
        GlobalStore.kraInfoObject.addressLine1 = `${resultObj.AppPerAdd1} ${resultObj.AppPerAdd2 || ""
          } ${resultObj.AppPerAdd3 || ""}`;
        GlobalStore.kraInfoObject.addressLine1 =
          GlobalStore.kraInfoObject.addressLine1; //.replace(/[^a-zA-Z0-9 ]/g, " ")

        GlobalStore.kraInfoObject.corrAddress = `${resultObj.AppCorAdd1} ${resultObj.AppCorAdd2 || ""
          } ${resultObj.AppCorAdd3 || ""}`;
        GlobalStore.kraInfoObject.corrAddress =
          GlobalStore.kraInfoObject.corrAddress; //.replace(/[^a-zA-Z0-9 ]/g, " ")
        GlobalStore.kraInfoObject.pincode = resultObj.AppPerPincd;
        GlobalStore.kraInfoObject.corrPincode = resultObj.AppCorPincd;
        GlobalStore.personaldetails.fsfullName = resultObj.FatherName
          ? resultObj.FatherName
          : GlobalStore.personaldetails.fsfullName;
        clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
        clientPartialDetails_ao.gender = responseObj?.Gender;
        GlobalStore.personaldetails.gender = responseObj?.Gender;
        clientPartialDetails_ao.addressLine1 =
          GlobalStore.kraInfoObject.addressLine1;
        clientPartialDetails_ao.PinCode = GlobalStore.kraInfoObject.pincode;
        clientPartialDetails_ao.corrAddress =
          GlobalStore.kraInfoObject.corrAddress;
        clientPartialDetails_ao.corrPincode =
          GlobalStore.kraInfoObject.corrPincode;
        clientPartialDetails_ao.fsfullName =
          GlobalStore.personaldetails.fsfullName;
        clientPartialDetails_ao.sameAsPermanent =
          GlobalStore.kraInfoObject.addressLine1 ==
            GlobalStore.kraInfoObject.corrAddress
            ? true
            : false;
        // } else {
        //     clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
        // }

        //getKraDocumentUpload(responseObj);
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        registerCleverTapEventAfterProceed();
        gtmService({ action: "PAN_DOB", label: "Step_Complete" });
        // if (!(objAccType === 'RMINV' && !GlobalStore.isKRA)) {
        setShowSubmitModal(true);
        // }
        if (
          skipUrlBoolean &&
          prodObj?.createdBy !== null &&
          prodObj?.createdBy !== undefined
        ) {
          setDocumentInfo({
            totalDocs: [],
            totalDocsCount: 0,
            uploadedDocsCount: 0,
          });
          setIsLoading(false);
        } else {
          setIsLoading(false);
        } //  if (applicationIdExists) history.push(GlobalStore.nextIncompleteStage);
        // else {
        //   // history.push(dashboardUrl.profile);
        //   // setIsLoading(false);
        //   setShowSubmitModal(true);
        // }
      }
    }
  }

  const panValidationCallback = (res: any, callBackFunction: Function) => {
    if (!res || res.error) {
      if (panInvalidMsg?.includes(res.error)) {
        setPanInvalidMsg(panInvalidMsg);
      } else {
        setPanInvalidMsg(panInvalidMsg + res.error);
      }
      setIsLoading(false);
    } else {
      if (res && res.data) {
        panValidationResp = res.data;
        if (res.data?.Dob === "N" || res.data?.Name === "N" || res.data?.PanStatus === "N" || res.data?.SeedingStatus === "N") {
          const getHolder = accHolders.find(a => a.pan == res.data.PanNo)
          setErrorFoundInPanValidation(false);
          const err = getHolder && getHolder.id ? `Holder ${getHolder.id} error: ` : ""
          setPanInvalidMsg(err + checkPanValidationMsgs(res.data));
        }
        if (res?.data?.SeedingStatus === "Y") {
          isPanLinkedToAadharRef.current = true;
        } else {
          isPanLinkedToAadharRef.current = false;
        }
        if (res.data?.Dob === "N" || res.data?.Name === "N" || res.data?.PanStatus === "N" || res.data?.SeedingStatus === "N") {
          setIsLoading(false);
        } else {
          setErrorFoundInPanValidation(true);
          if (
            values.pan === extractPanResponse?.id_number &&
            moment(values.dob).format("YYYY-MM-DD") === extractPanResponse?.date_of_birth
          ) {
            setDobChecked(true);
          } else {
            setDobChecked(false);
          }

          validatePANNew(
            res?.data?.SeedingStatus,
            res?.data?.SeedingStatusMsg,
            res?.data?.PanStatus
          );
        }
      }
    }
  };

  const panValidation = (
    panObject: {
      panNo: string;
      name: string;
      dob: string;
      source: string;
    },
    callBackFunction: Function
  ) => {
    APanVerification((res: any) => {
      panValidationCallback(res, callBackFunction);
    }, panObject);
  };

  function navigateTo(applicationIdExists: boolean | undefined, reqObj?: any) {
    registerCleverTapEventAfterProceed();
    gtmService({ action: "PAN_DOB", label: "Step_Complete" });
    const clientPartialDetails_ao = JSON.parse(
      window.localStorage.getItem("clientPartialDetails_ao") || "{}"
    );
    if (showSubmitModal) {
      if (
        !clientPartialDetails_ao.ckycNo ||
        clientPartialDetails_ao.ckycNo === "" ||
        !clientPartialDetails_ao.isKRA
      ) {
        if (
          skipUrlBoolean &&
          prodObj?.createdBy !== null &&
          prodObj?.createdBy != undefined
        ) {
          // history.push(dashboardUrl.profile);
          navigate(dashboardUrl.profile)
        } else {
          // history.push(containerUrl.dgLocker);
          navigate(containerUrl.dgLocker)
        }
      } else if (applicationIdExists) {
        // history.push(GlobalStore.nextIncompleteStage);
        navigate(GlobalStore.nextIncompleteStage)
      }
      else {
        if (!errCode && errCode.length === 0)
          navigate(dashboardUrl.profile)
      }
    }
    if (
      (skipUrlBoolean &&
        prodObj?.createdBy !== null &&
        prodObj?.createdBy != undefined &&
        applicationIdExists) || ((objAccType === 'RMINV' && !GlobalStore.isKRA))
    ) {
      navigate(GlobalStore.nextIncompleteStage)
    }
    if (
      reqObj !== null &&
      reqObj !== undefined &&
      reqObj?.skipUrlBoolean &&
      reqObj?.rmid !== null &&
      reqObj?.rmid != undefined &&
      applicationIdExists
    ) {
      // history.push(GlobalStore.nextIncompleteStage);
      navigate(GlobalStore.nextIncompleteStage)
    }
    if (!showSubmitModal) {
      // if (!(objAccType === 'RMINV' && !GlobalStore.isKRA)) {
      setShowSubmitModal(true);
      // }
      setIsLoading(false);
    }
  }

  function nextprocess(kycobj: any) {
    if (isPanLinkedToAadharRef.current) {
      setIsLoading(true);
      const reqObj = {
        dbo: values.pan ? `${moment(values.dob).format("DD/MM/YYYY")}` : `${moment(values.gurdianDOB).format("DD/MM/YYYY")}`,
        panno: values.pan || values.gurdianPanNo,
        applicationId: GlobalStore.applicationID,
        clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
        // documentInfo: saveDetails,
        leadId: GlobalStore.leadId,
        CreatedBy:
          skipUrlBoolean && !!prodObj?.createdBy && prodObj?.createdBy
            ? parseInt(prodObj?.createdBy)
            : 0,
      };
      AGetKraDetails(
        (res: any) =>
          kraDobCheckNew(
            res,
            GlobalStore?.applicationID !== null &&
              GlobalStore?.applicationID !== undefined
              ? true
              : false
          ),
        reqObj
      );
    } else {
      setIsNormalClient(true);
      GlobalStore.isNormalClient = true;
      const clientPartialDetails_ao = JSON.parse(
        window.localStorage.getItem("clientPartialDetails_ao") || "{}"
      );
      clientPartialDetails_ao.isNormalClient = GlobalStore.isNormalClient;
      window.localStorage.setItem(
        "clientPartialDetails_ao",
        JSON.stringify(clientPartialDetails_ao)
      );
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (objAccType == "RMINV") {
      setSkipUrlBoolean(true)
      setPanFileUploadedLoader(false);
      setPanFileUploaded(true);
      setWillDoLater(true);
    }
  }, [objAccType])

  const updateHolder = (id: any, field: any, value: any) => {
    setAccHolders(prev =>
      prev.map(h =>
        h.id === id ? { ...h, [field]: value } : h
      )
    );
    setErrCode('')
    if (field == 'email') {
      setHolderVerificationStates((prev: any) => ({
        ...prev,
        [id]: {
          ...prev[id],
          emailVerified: false,
          emailTimer: 0
        },
      }));
      setHolderOtpStates((prev: any) => ({
        ...prev,
        [id]: {
          ...prev[id],
          emailSent: false,
        },
      }));
    }
    if (field == 'mobile') {
      setHolderVerificationStates((prev: any) => ({
        ...prev,
        [id]: {
          ...prev[id],
          mobileVerified: false,
          mobileTimer: 0
        },
      }));
      setHolderOtpStates((prev: any) => ({
        ...prev,
        [id]: {
          ...prev[id],
          mobileSent: false,
        },
      }));
    }
  };

  const handleHolderBlur = (id: number, field: string, error: any, event: any) => {
    const value = event?.target?.value;
    let msg = "";

    if (error?.required) msg = errorMsg(errorCode.FE57);
    else if (!!value && value.slice(-1) === " ") msg = errorMsg(errorCode.FE55);
    else if (!!value && value.length > 0 && !value.replace(/\s/g, "").length)
      msg = errorMsg(errorCode.FE55);

    setHolderErrors((prev: any) => ({
      ...prev,
      [id]: { ...prev[id], [field]: msg },
    }));
  };

  const handleHolderPanBlur = (id: number, error: any) => {
    const msg = error?.pattern ? "" : errorMsg(errorCode.FE07);
    setHolderErrors((prev: any) => ({
      ...prev,
      [id]: { ...prev[id], pan: msg },
    }));
  };

  const handleHolderDobBlur = (id: number, err: any) => {
    setHolderErrors((prev: any) => ({
      ...prev,
      [id]: { ...prev[id], dob: err ? "Invalid DOB" : "" },
    }));
  };

  const removeHolder = (id: number) => {
    setAccHolders(prev => prev.filter(h => h.id !== id));
  };

  return (
    <>
      <div className={"pan" + (isLoading ? " op05" : "")} style={{ maxWidth: "410px" }}>
        <div className="banner">
          <img className="bannerImg" src={regbanner} alt="" aria-hidden="true" />
        </div>
        <h1 className="panHeading">Let’s Get Started</h1>
        <div className="panInfo">
          <span>
            Please provide your PAN Card details below to proceed
          </span>
        </div>
        <div className="panForm" style={{ maxWidth: "410px" }}>
          <form>
            <fieldset disabled={isLoading}>
              <legend className="sr-only">PAN verification</legend>
              {panFileUploadedLoader && (
                <div className="row">
                  <Loader size={20} />
                </div>
              )}
              {invalidPanFieldUploadedMsg != "" && (
                <div className="errMsgBlck">
                  <ErrMsg>
                    <span>{invalidPanFieldUploadedMsg}</span>
                  </ErrMsg>
                </div>
              )}
              {panFileUploaded &&
                !panFileUploadedLoader &&
                invalidPanFieldUploadedMsg == "" && (
                  <>
                    <fieldset>
                      <legend className="sr-only">PAN verification</legend>
                      {accHolders.map((holder: any) => (
                        <div key={holder.id}>
                          <div
                            className="row"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span className="inptLblTitle">
                              Account Holder {holder.id} {holder.isPrimary && "(Primary)"}
                            </span>

                            {!holder.isPrimary && holder.id === 3 && (
                              <span
                                style={{
                                  color: "#C20F0F",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                  fontSize: "14px",
                                  fontWeight: 400,
                                }}
                                onClick={() => removeHolder(holder.id)}
                              >
                                Remove Holder
                              </span>
                            )}
                          </div>
                          {/* First Name */}
                          <div className="row">
                            <label className="inptLbl" htmlFor={`firstName-${holder.id}`}>First Name</label>
                            <InputField
                              id={`firstName-${holder.id}`}
                              name={`firstName-${holder.id}`}
                              className="panInput"
                              disabled={holder.isDisabled}
                              defaultValue={holder.firstName}
                              onChange={(value) => {
                                updateHolder(holder.id, "firstName", value)
                                holder.isPrimary && onChange("firstName", value)
                              }}
                              required={true}
                              onBlur={(error, event) => handleHolderBlur(holder.id, "firstName", error, event)}
                              type="text"
                              placeholder="Eg. Pranav"
                              errorText={holderErrors[holder.id]?.firstName}
                              maxLength={20}
                            />
                          </div>

                          {/* Middle Name */}
                          <div className="row">
                            <label className="inptLbl" htmlFor={`middleName-${holder.id}`}>Middle Name</label>
                            <InputField
                              id={`middleName-${holder.id}`}
                              name={`middleName-${holder.id}`}
                              className="panInput"
                              defaultValue={holder.middleName}
                              disabled={holder.isDisabled}
                              onChange={(value) => {
                                updateHolder(holder.id, "middleName", value)
                                holder.isPrimary && onChange("middleName", value)
                              }}
                              onBlur={(error, event) => handleHolderBlur(holder.id, "middleName", error, event)}
                              type="text"
                              placeholder="Eg. Prashant"
                              errorText={holderErrors[holder.id]?.middleName}
                              maxLength={20}
                            />
                          </div>

                          {/* Last Name */}
                          <div className="row">
                            <label className="inptLbl" htmlFor={`lastName-${holder.id}`}>Last Name</label>
                            <InputField
                              id={`lastName-${holder.id}`}
                              name={`lastName-${holder.id}`}
                              className="panInput"
                              defaultValue={holder.lastName}
                              disabled={holder.isDisabled}
                              onChange={(value) => {
                                updateHolder(holder.id, "lastName", value)
                                holder.isPrimary && onChange("lastName", value)
                              }}
                              onBlur={(error, event) => handleHolderBlur(holder.id, "lastName", error, event)}
                              type="text"
                              placeholder="Eg. Joshi"
                              errorText={holderErrors[holder.id]?.lastName}
                              maxLength={40}
                            />
                          </div>

                          {/* PAN */}
                          <div className="row">
                            <label className="inptLbl" htmlFor={`pan-${holder.id}`}>Enter PAN</label>
                            <InputField
                              id={`pan-${holder.id}`}
                              name={`pan-${holder.id}`}
                              className="panInput"
                              defaultValue={holder.pan}
                              disabled={holder.isDisabled}
                              onChange={(value) => {
                                updateHolder(holder.id, "pan", value.toUpperCase())
                                holder.isPrimary && onChange("pan", value.toUpperCase())
                              }}
                              onBlur={(error) => handleHolderPanBlur(holder.id, error)}
                              type="text"
                              placeholder="Eg. ABCDE1234F"
                              pattern={pan}
                              errorText={holderErrors[holder.id]?.pan}
                              maxLength={10}
                              suffix={holder.validPan ? <i className="edel-icon-tick" aria-hidden="true" /> : <></>}
                            />
                          </div>

                          {/* DOB */}
                          <div className="row">
                            <label className="inptLbl" htmlFor={`dob-${holder.id}`}>Date of Birth</label>
                            <Calender
                              id={`dob-${holder.id}`}
                              name={`dob-${holder.id}`}
                              onDateSelect={(val) => {
                                holder.isPrimary && onChange("dob", val)
                                updateHolder(holder.id, "dob", val)
                              }}
                              defaultDate={holder.dob ? new Date(holder.dob) : undefined}
                              placeholderText={"Select Date of Birth"}
                              maxDate={new Date(new Date().setFullYear(new Date().getFullYear() - 18))}
                              minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 100))}
                              onBlur={(e) => handleHolderDobBlur(holder.id, e)}
                              // disable={holder.isDisabled}
                              isError={holderErrors[holder.id]?.dob ? true : false}
                              errorText={holderErrors[holder.id]?.dob}
                            />
                          </div>

                          {/* Relationship */}
                          {!holder.isPrimary &&
                            <div className="row">
                              <label className="inptLbl" htmlFor={`relation-${holder.id}`}>Email mobile belongs to *</label>
                              <DropdownSearch
                                id={`relation-${holder.id}`}
                                name="relation"
                                searchLength={0}
                                options={relationShipList}
                                searchKey="display"
                                placeholder="Select Relationship"
                                isDownArrow={true}
                                defaultValue={
                                  relationShipList.find((x) => x.value === holder.relation)?.display || ""
                                }
                                disabled={holder.isDisabled}
                                onOptionSelect={(item) => updateHolder(holder.id, "relation", item.value)}
                              />
                            </div>
                          }

                          {/* Email Section */}
                          <div className={!holder.isPrimary && !holderVerificationStates[holder.id]?.emailVerified ? "email" : ""}>
                            <div className="row emlInput">
                              <label className="inptLbl" htmlFor={`email-${holder.id}`}>Email ID</label>
                              <InputField
                                id={`email-${holder.id}`}
                                name={`email-${holder.id}`}
                                pattern={emailRegex}
                                onChange={(value) => {
                                  updateHolder(holder.id, "email", value)
                                }}
                                onBlur={(error, e) => {
                                  const email = holder.email;
                                  if (!emailRegex.test(email)) {
                                    setHolderErrors((prev: any) => ({
                                      ...prev,
                                      [holder.id]: {
                                        ...prev[holder.id],
                                        email: "Invalid email format",
                                      },
                                    }));
                                  } else {
                                    setHolderErrors((prev: any) => ({
                                      ...prev,
                                      [holder.id]: { ...prev[holder.id], email: "" },
                                    }));
                                  }
                                }}
                                placeholder="Eg. example@email.com"
                                errorText={holderErrors[holder.id]?.email}
                                type="email"
                                defaultValue={holder.email}
                                suffix={
                                  holderVerificationStates[holder.id]?.emailVerified ? (
                                    <i className="edel-icon-tick" aria-hidden="true" />
                                  ) : (
                                    <></>
                                  )
                                }
                                helpText={""}
                                helpTextColor="grey"
                                disabled={holder.isPrimary}
                              />
                            </div>
                            {!holder.isPrimary && !holderVerificationStates[holder.id]?.emailVerified && (
                              <div className="emlVrfy">
                                <Verify
                                  btnName={
                                    holderOtpStates[holder.id]?.emailTimer > 0 && !holderVerificationStates[holder.id]?.emailVerified
                                      ? `Resend (${holderOtpStates[holder.id]?.emailTimer}s)`
                                      : holderOtpStates[holder.id]?.emailSent
                                        ? "Resend OTP"
                                        : "Verify"
                                  }
                                  disabled={
                                    !holder.email ||
                                    holderErrors[holder.id]?.email ||
                                    holderOtpStates[holder.id]?.emailTimer > 0 ||
                                    holderVerificationStates[holder.id]?.emailVerified
                                  }
                                  onClick={() => {
                                    handleSendEmailOTP(holder.id, holder.email);
                                    gtmService({
                                      action: "JOINT_ACCOUNT",
                                      label: `EMAIL_VERIFY_HOLDER_${holder.id}`,
                                    });
                                  }}
                                />
                              </div>
                            )}
                          </div>

                          {/* Email OTP Section */}
                          {holderOtpStates[holder.id]?.emailSent &&
                            !holderVerificationStates[holder.id]?.emailVerified && (
                              <div className="otpSection">
                                <RegOtp
                                  label="Enter Email OTP"
                                  otpTimer={15}
                                  eleId={`email_otp_${holder.id}_`}
                                  onChange={(val) => validateOtp(holder.id, 'email', val)}
                                  resendClicked={() => {
                                    handleSendEmailOTP(holder.id, holder.email);
                                    gtmService({
                                      action: "JOINT_ACCOUNT",
                                      label: `EMAIL_OTP_RESEND_HOLDER_${holder.id}`
                                    });
                                  }}
                                  disableOtp={false}
                                  invalidOtp={invalidEmailOtp}
                                />
                              </div>
                            )}

                          {/* Mobile Section */}
                          <div className={!holder.isPrimary && !holderVerificationStates[holder.id]?.mobileVerified ? "email" : ""}>
                            <div className="row emlInput">
                              <label className="inptLbl" htmlFor={`mobile-${holder.id}`}>Mobile No</label>
                              <InputField
                                id={`mobile-${holder.id}`}
                                name={`mobile-${holder.id}`}
                                pattern={phoneNo}
                                onChange={(value) => {
                                  const cleanedValue = value.replace(/\D/g, "");
                                  updateHolder(holder.id, "mobile", cleanedValue);
                                  setHolderErrors((prev: any) => ({
                                    ...prev,
                                    [holder.id]: { ...prev[holder.id], mobile: "" },
                                  }));
                                }}
                                onBlur={(error, e) => {
                                  const mobile = holder.mobile?.trim();
                                  if (!mobile || mobile.length !== 10 || !phoneNo.test(mobile)) {
                                    setHolderErrors((prev: any) => ({
                                      ...prev,
                                      [holder.id]: { ...prev[holder.id], mobile: "Invalid mobile number" },
                                    }));
                                    return;
                                  }
                                  setHolderErrors((prev: any) => ({
                                    ...prev,
                                    [holder.id]: { ...prev[holder.id], mobile: "" },
                                  }));
                                }}
                                placeholder="Eg. 9876543210"
                                errorText={holderErrors[holder.id]?.mobile}
                                type="tel"
                                defaultValue={holder.mobile}
                                suffix={
                                  holderVerificationStates[holder.id]?.mobileVerified ? (
                                    <i className="edel-icon-tick" aria-hidden="true" />
                                  ) : (
                                    <></>
                                  )
                                }
                                helpText={""}
                                helpTextColor="grey"
                                maxLength={10}
                                disabled={holder.isPrimary}
                              />
                            </div>
                            {!holder.isPrimary && !holderVerificationStates[holder.id]?.mobileVerified && (
                              <div className="emlVrfy">
                                <Verify
                                  btnName={
                                    holderOtpStates[holder.id]?.mobileTimer > 0 && !holderVerificationStates[holder.id]?.mobileVerified
                                      ? `Resend (${holderOtpStates[holder.id]?.mobileTimer}s)`
                                      : holderOtpStates[holder.id]?.mobileSent
                                        ? "Resend OTP"
                                        : "Verify"
                                  }
                                  disabled={
                                    !holder.mobile ||
                                    holder.mobile.length !== 10 ||
                                    holderErrors[holder.id]?.mobile ||
                                    holderOtpStates[holder.id]?.mobileTimer > 0 ||
                                    holderVerificationStates[holder.id]?.mobileVerified
                                  }
                                  onClick={() => {
                                    handleSendMobileOTP(holder.id, holder.mobile);
                                    gtmService({
                                      action: "JOINT_ACCOUNT",
                                      label: `MOBILE_VERIFY_HOLDER_${holder.id}`,
                                    });
                                  }}
                                />
                              </div>
                            )}
                          </div>

                          {/* Mobile OTP Section */}
                          {holderOtpStates[holder.id]?.mobileSent &&
                            !holderVerificationStates[holder.id]?.mobileVerified && (
                              <div className="otpSection">
                                <RegOtp
                                  label="Enter Mobile OTP"
                                  otpTimer={holderOtpStates[holder.id]?.mobileTimer || 0}
                                  eleId={`mobile_otp_${holder.id}_`}
                                  onChange={(val) => validateOtp(holder.id, 'mobile', val)}
                                  resendClicked={() => {
                                    handleSendMobileOTP(holder.id, holder.mobile);
                                    gtmService({
                                      action: "JOINT_ACCOUNT",
                                      label: `MOBILE_OTP_RESEND_HOLDER_${holder.id}`
                                    });
                                  }}
                                  disableOtp={false}
                                  invalidOtp={invalidOtp}
                                />
                              </div>
                            )}
                        </div>
                      ))}
                    </fieldset>
                    {accHolders?.length < 3 && !prodObj.uccCode &&
                      <div className="addAcc">
                        <div>
                          <img className="addIcon" src={addIcon} alt="" aria-hidden="true" />
                        </div>
                        <div>
                          <button
                            type="button"
                            className="statusLink"
                            style={{ textDecoration: "underline" }}
                            onClick={() => {
                              try {
                                const screen_name = getScreenName(window.location.pathname);
                                if (screen_name) {
                                  mixpanelService({
                                    event: mixpanelEvents.CTA_CLICKED,
                                    screen_name,
                                    text: "Add Another Account Holder (Optional)",
                                    cta_type: "sticky",
                                    cta_class: "secondary",
                                    cta_service: "AOJ",
                                  });
                                }
                              } catch (e) {
                                console.error("mixpanel cta_clicked failed", e);
                              }
                              handleAddHolder();
                            }}
                          >
                            Add Another Account Holder (Optional)
                          </button>
                        </div>
                      </div>
                    }
                    <div className="termList mrt41">
                      <Checkbox
                        checked={consent}
                        name="termone"
                        onChange={() => { }}
                      />
                      <span className="mrl13 linkLabel">
                        I authorize Nuvama to pull KYC records through C-KYC or KRA
                      </span>
                    </div>

                    {showSubmitModal && (
                      <div
                        style={{
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                          height: "160px",
                        }}
                      >
                        <Backdrop
                          width="width50"
                          isShow={modalDisplayText}
                          isCloseIcon={false}
                          ariaLabelledBy="pan-joint-modal-title"
                        >
                          <h2 id="pan-joint-modal-title">Please Note!</h2>
                          <div className="explainInfo">
                            {modalDisplayText ? (
                              <div
                                className="modaltext-Div"
                                style={{ fontSize: "20px" }}
                              >
                                {modalDisplayText}
                              </div>
                            ) : (
                              "Loading..."
                            )}
                          </div>
                          <div className="mrt16  mrb16 sunBtn">
                            <button
                              className={`panpage-modalSubmit ${documentsInfo.totalDocsCount !==
                                documentsInfo.uploadedDocsCount
                                ? "disable"
                                : ""
                                }`}
                              onClick={() => {
                                try {
                                  const screen_name = getScreenName(window.location.pathname);
                                  if (screen_name) {
                                    mixpanelService({
                                      event: mixpanelEvents.CTA_CLICKED,
                                      screen_name,
                                      text: "OK, Proceed",
                                      cta_type: "sticky",
                                      cta_class: "primary",
                                      cta_service: "AOJ",
                                    });
                                  }
                                } catch (e) {
                                  console.error("mixpanel cta_clicked failed", e);
                                }
                                navigate(dashboardUrl.profile);
                              }}
                              type="submit"
                              disabled={
                                documentsInfo.totalDocsCount !==
                                documentsInfo.uploadedDocsCount
                              }
                            >
                              {documentsInfo.totalDocsCount !==
                                documentsInfo.uploadedDocsCount
                                ? "Please Wait"
                                : "OK, Proceed"}
                            </button>
                          </div>
                        </Backdrop>
                      </div>
                    )}

                    {utmObj &&
                      Object.keys(utmObj).length > 0 &&
                      utmObj.utm_source &&
                      utmObj.utm_content &&
                      utmObj.utm_campaign && (
                        <div className="termList mrt41">
                          <span className="linkLabel assisted-label">
                            You are being assisted
                          </span>
                        </div>
                      )}

                    {/* Error Msg Start*/}
                    {errCode && (
                      <div className="errMsgBlck">
                        <ErrMsg>
                          {typeof errCode === "number" ? (
                            <>
                              <span>We are facing some technical issue.</span>
                              <span>
                                Please try after sometime (error code:{errCode})
                              </span>
                            </>
                          ) : (
                            <span>{errCode}</span>
                          )}
                        </ErrMsg>
                      </div>
                    )}
                    {/* Error Msg End*/}
                    {/* Pan Matching  Error Msg Start */}
                    {panInvalidMsg !== "" && panInvalidMsg?.length > 0 && (
                      <div className="errMsgBlck">
                        <ErrMsg>
                          <span>{panInvalidMsg}</span>
                        </ErrMsg>
                      </div>
                    )}
                    {/* Pan Matching  Error Msg End */}
                    <div className="row">
                      <Button
                        onClick={handleSubmit} //isNormalClient ? handleContinue :
                        btnName={isNormalClient ? "Continue" : "Proceed"}
                        disabled={
                          // !values?.dob ||
                          // !values?.firstName ||
                          // (!values?.pan || errors?.pan) ||
                          (errCode === "" && isNormalClient && (!panNumberMatched || !dobChecked)) ||
                          !consent ||
                          liveLocationCheck.checkPhotoLiveness ||
                          liveLocationCheck.checkLocation ||
                          (skipUrlBoolean ? false : !panOCR)
                          // || errCode
                        }
                        isLoading={isLoading}
                        type="submit"
                      />
                    </div>
                  </>
                )}
            </fieldset>
          </form>
        </div>
      </div>
    </>
  );
};

export default PANInfoJoint;
